import React, { Component } from 'react';
import { DatePicker } from 'antd';
import _ from 'lodash';
import $ from 'jquery';
import moment from 'moment';

import './styles.module.scss';
import './cibc.css';

const VC_CONFIG = _.get(window, 'VC_CONFIG');

export default class CibcCalculation extends Component {
  formRef = React.createRef();
  state = {
    query: {},
    storeInfo: undefined,
    listInfo: {
      current: 1, //目前頁數
      page_size: 10, //一頁幾筆
      total: 1, //以此query條件，總共幾筆資料
      rows: [],
    },
    store: [],
    area: null,
    branch: [],
    loading: false,
  };

  componentDidMount() {
    cibcCalculationDidMount();
  }

  render() {
    return (
      <main class='bg-light' id='calculation'>
        <div class='container'>
          <div class='breadcrumb-wrap py-4 m-0 '>
            <nav aria-label='breadcrumb' style={{ textAlign: 'left' }}>
              <ol class='breadcrumb '>
                <li class='breadcrumb-item'>
                  <a href={`${VC_CONFIG.INDEX_URL}`}>首頁</a>
                </li>
                <li class='breadcrumb-item'>
                  <a href={`${VC_CONFIG.INDEX_URL}/cibc`}>保險經紀人</a>
                </li>
                <li class='breadcrumb-item active' aria-current='page'>
                  保險試算表
                </li>
              </ol>
            </nav>
          </div>
          <section class='pt-5 pb-0'>
            <div class='basic-tabs-border mb-5'>
              <ul class='nav nav-pills' id='pills-tab'>
                <li class='nav-item'>
                  <a class='nav-link' href={`${VC_CONFIG.INDEX_URL}/cibc`}>
                    首頁
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-about`}>
                    保險經紀人
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-service`}>
                    服務項目
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-product`}>
                    商品資訊
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-partner`}>
                    合作夥伴
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-activity`}>
                    活動剪影
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-servicepoint`}>
                    服務據點
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-recruit`}>
                    人才招募
                  </a>
                </li>
              </ul>
            </div>
          </section>
          <div class='wrapper cibc-menu cibc-cal'>
            <div>
              <div class='contentbox'>
                <div class='blocktitle'>
                  <span>保障試算</span>
                </div>
                <div class='infoblock'>
                  <div class='row-title'>
                    <strong>個人資料</strong>
                  </div>
                  <div class='row-comment'>
                    <div class='inputbox'>
                      <ul>
                        <li class='fullwidth'>
                          <div class='text' style={{ paddingLeft: '0' }}>
                            <span>姓名</span>
                          </div>
                          <div class='input'>
                            <input type='text' name='name' />
                          </div>
                        </li>
                        <li>
                          <div class='text' style={{ paddingLeft: '0' }}>
                            <span>生日</span>
                          </div>
                          <div class='input' id='datepickerbox'>
                            <DatePicker
                              id='datepicker'
                              onChange={DateonChange}
                              style={{ width: '100%' }}
                            />
                          </div>
                        </li>
                        <li>
                          <div class='text' style={{ paddingLeft: '0' }}>
                            <span>性別</span>
                          </div>
                          <div class='input'>
                            <select name='gender'>
                              <option value=''>請選擇性別</option>
                              <option value='男'>男</option>
                              <option value='女'>女</option>
                            </select>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class='resultbox'>
                      <span>您的保險年齡</span>
                      <span class='resultstr age'>0</span>
                      <span>歲,離勞保退休年齡</span>
                      <span class='resultstr year'>0</span>
                      <span>年</span>
                    </div>
                  </div>
                </div>
                <div class='incomeblock'>
                  <div class='row-title'>
                    <strong>收入狀況</strong>
                  </div>
                  <div class='row-comment'>
                    <div class='inputbox'>
                      <ul>
                        <li>
                          <div class='text'>
                            <span>每月固定收入</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='stableincome'
                              id='stableincome'
                              onkeyup="value=value.replace(/[^\d]/g,'').replace(/0*(\d*)/,'$1') "
                            />
                          </div>
                          <div class='unit'>
                            <span>元</span>
                          </div>
                        </li>
                        <li>
                          <div class='text'>
                            <span>每月其他收入</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='otherincome'
                              id='otherincome'
                              onkeyup="value=value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='unit'>
                            <span>元</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class='resultbox'>
                      <span>收入小計</span>
                      <span class='resultstr incomemoney'>0</span>
                      <span>元/月</span>
                    </div>
                  </div>
                </div>
                <div class='expenditureblock'>
                  <div class='row-title'>
                    <strong>支出狀況</strong>
                  </div>
                  <div class='row-comment'>
                    <div class='inputbox'>
                      <ul>
                        <li>
                          <div class='text'>
                            <span>房貸/房租支出</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='mortgageprice'
                              onkeyup="value=value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='middle'>
                            <span>元/月，剩餘年度</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='mortgageyear'
                              onkeyup="value=value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='unit'>
                            <span>年</span>
                          </div>
                        </li>
                        <li>
                          <div class='text'>
                            <span>車貸支出</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='carloanprice'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='middle'>
                            <span>元/月，剩餘年度</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='carloanyear'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='unit'>
                            <span>年</span>
                          </div>
                        </li>
                        <li>
                          <div class='text'>
                            <span>其他貸款</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='otherloansprice'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='middle'>
                            <span>元/月，剩餘年度</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='otherloansyear'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='unit'>
                            <span>年</span>
                          </div>
                        </li>
                        <li>
                          <div class='text'>
                            <span>教育費用支出</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='eduprice'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='middle'>
                            <span>元/月，剩餘年度</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='eduyear'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='unit'>
                            <span>年</span>
                          </div>
                        </li>
                        <li class='lastaverage'>
                          <div class='text'>
                            <span>離退休生活平均月支出</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='averageprice'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='middle'>
                            <span>元/月，離勞保退休年齡</span>
                            <span id='averageyear'>0</span>
                            <span>年</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class='resultbox'>
                      <span>支出小計</span>
                      <span class='resultstr money'>0</span>
                      <span>元/月</span>
                    </div>
                    <div class='demandbox none'>
                      <div class='titlebox'>
                        <span>您的保障需求</span>
                      </div>
                      <div class='noticebox'>
                        <div class='text'>
                          <span>不含月生活支出</span>
                        </div>
                        <div class='price'>
                          <span id='excludeprice' class='priceText'>
                            0
                          </span>
                        </div>
                        <div class='middle'>
                          <span>元/年，含月生活支出</span>
                        </div>
                        <div class='price'>
                          <span id='includeprice' class='priceText'>
                            0
                          </span>
                        </div>
                        <div class='last'>
                          <span>元/年</span>
                        </div>
                      </div>
                      <div class='colorbox'>
                        <ul class='colorlist'>
                          <li class='first'>
                            <i class='one' />
                            <span>房貸/房租支出</span>
                          </li>
                          <li>
                            <i class='two' />
                            <span>車貸支出</span>
                          </li>
                          <li>
                            <i class='three' />
                            <span>其他貸款</span>
                          </li>
                          <li>
                            <i class='four' />
                            <span>退休生活支出</span>
                          </li>
                          <li class='last'>
                            <i class='five' />
                            <span>教育費用支出</span>
                          </li>
                        </ul>
                      </div>
                      <div class='chartbox' />
                      <div class='resultbox'>
                        <ul class='resultlist'>
                          <li class='result'>
                            <span class='text'>壽險保障需求</span>
                            <span id='lifeinsuranceprice' class='price'>
                              0
                            </span>
                            <span class='unit'>元</span>
                          </li>
                          <li class='result'>
                            <span class='text'>每個月收入-支出餘額</span>
                            <span id='inandoutcomeprice' class='price sp'>
                              0
                            </span>
                            <span class='unit'>元</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='hospitalizebox'>
                  <div class='shadowbox'>
                    <div class='row-title'>
                      <strong>住院日額</strong>
                    </div>
                    <div class='row-comment'>
                      <ul>
                        <li class='first'>
                          <div class='title'>
                            <span>已投保住院日額</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='hospitalprice'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='text'>
                            <span>元/日</span>
                          </div>
                        </li>
                        <li>
                          <div class='title'>
                            <span>選擇居住地主要醫院</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='hospital'
                              placeholder='請參考主要醫院病房費'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='text'>
                            <span>元/日</span>
                          </div>
                        </li>
                        <div class='text'>
                          <a href='#' id='choosehospital'>
                            查詢主要醫院病房費
                          </a>
                        </div>
                      </ul>
                      <div class='resultbox'>
                        <span class='text'>尚需補強</span>
                        <span class='price hospital'>0</span>
                        <span class='unit'>元/日</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='longtermcarebox'>
                  <div class='shadowbox'>
                    <div class='row-title'>
                      <strong>長照&失能需求</strong>
                    </div>
                    <div class='row-comment'>
                      <ul>
                        <li class='first'>
                          <div class='text'>
                            <span>預估長照或失能月支出</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='incapacitation'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='unit'>
                            <span>元/月</span>
                          </div>
                        </li>
                        <li>
                          <div class='text'>
                            <span>社會補助</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='allowance'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='unit'>
                            <span>元/月</span>
                          </div>
                        </li>
                        <li>
                          <div class='text'>
                            <span>自購商業保險</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='selfinsurance'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='unit'>
                            <span>元/月</span>
                          </div>
                        </li>
                      </ul>
                      <div class='resultbox'>
                        <span class='text'>尚需補強</span>
                        <span class='price allow'>0</span>
                        <span class='unit'>元/月</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='retirebox'>
                  <div class='row-title'>
                    <strong>退休生活</strong>
                  </div>
                  <div class='row-comment'>
                    <div class='inputbox'>
                      <ul>
                        <li>
                          <div class='text'>
                            <span>預估退休年齡</span>
                          </div>
                          <div class='input'>
                            <input
                              type='text'
                              name='estimated'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='middle'>
                            <span>歲，預估退休後餘命</span>
                          </div>
                          <div class='input'>
                            <input type='text' name='survival' />
                          </div>
                          <div class='unit'>
                            <span>年</span>
                          </div>
                          <div class='openimage'>
                            <span>預估參考值</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class='noticebox'>
                      <span>
                        依據內政部106年統計生平均壽命
                        <br />
                        男性:77歲，女性83歲
                      </span>
                    </div>
                    <div class='inputbox bottom'>
                      <ul>
                        <li class='allred'>
                          <div class='subtext'>
                            <span>預估退休後月支出</span>
                          </div>
                          <div class='subinput'>
                            <input
                              type='text'
                              name='retireoutlay'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='subunit'>
                            <span>元</span>
                          </div>
                        </li>
                        <li>
                          <div class='subtext'>
                            <span>勞保每月給付</span>
                          </div>
                          <div class='subinput'>
                            <input
                              type='text'
                              name='retirebilingual'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='subunit'>
                            <span>元</span>
                          </div>
                        </li>
                        <li>
                          <div class='subtext'>
                            <span>商業保險每月給付</span>
                          </div>
                          <div class='subinput'>
                            <input
                              type='text'
                              name='retireinsurance'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='subunit'>
                            <span>元</span>
                          </div>
                        </li>
                        <li>
                          <div class='subtext'>
                            <span>其他每月給付</span>
                          </div>
                          <div class='subinput'>
                            <input
                              type='text'
                              name='retireother'
                              onkeyup="value = value.replace(/[^\d]/g, '').replace(/0*(\d*)/, '$1') "
                            />
                          </div>
                          <div class='subunit'>
                            <span>元</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class='resultbox'>
                      <span class='text'>退休後每月尚差</span>
                      <span class='resultstr retiremoney'>0</span>
                      <span>元</span>
                    </div>
                  </div>
                </div>
                <div class='btnbox'>
                  <ul>
                    <li>
                      <a href='#' id='html2pdfBtn'>
                        匯出PDF檔
                      </a>
                    </li>
                    <li>
                      <a href={`${VC_CONFIG.INDEX_URL}/cibc-contact-us`}>
                        聯絡我們
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id='printcibxblock'
          style={{ fontVariant: 'normal', display: 'none' }}>
          <div class='borderbox' style={{ textAlign: 'left' }}>
            <div class='topbox'>
              <div class='contentbox'>
                <span>保障試算結果</span>
                <span>Insurance cost trial</span>
                <div class='infobox'>
                  <p class='red'>
                    依據您輸入的資料，保經試算出您的保障需求分析總表如下：
                  </p>
                  <p class='blue'>
                    可持本分析表就近至量販店與保險專員做諮詢與規劃服務
                  </p>
                </div>
              </div>
              <div class='logobox'>
                <img
                  alt=''
                  class='img-contain'
                  src={`${
                    VC_CONFIG.INDEX_URL
                  }/wp-content/themes/cec/assets/img/cibc/pdf/logo.png`}
                />
              </div>
            </div>
            <div class='middlebox'>
              <div class='sectionbox'>
                <div class='calbox'>
                  <div class='left'>
                    <span>個人資料</span>
                  </div>
                  <div class='right'>
                    <ul>
                      <li>
                        <span class='lefttitle'>姓名</span>
                        <span class='rightcontent infoname' />
                      </li>
                      <li>
                        <span class='lefttitle'>生日</span>
                        <span class='rightcontent infobirth' />
                      </li>
                      <li>
                        <span class='lefttitle'>性別</span>
                        <span class='rightcontent infogender' />
                      </li>
                    </ul>
                  </div>
                </div>
                <div class='resultbox'>
                  <span class='text'>您的保險年齡</span>
                  <span class='number inage' />
                  <span class='text'>歲，離勞保退休年齡</span>
                  <span class='number reage' />
                  <span class='text'>年</span>
                </div>
              </div>
              <div class='incomebox'>
                <div class='calbox'>
                  <div class='left'>
                    <span>收入狀況</span>
                  </div>
                  <div class='right'>
                    <ul>
                      <li>
                        <span class='lefttitle'>每月固定收入</span>
                        <span class='rightcontent incomeone' />
                      </li>
                      <li>
                        <span class='lefttitle'>每月其他收入</span>
                        <span class='rightcontent incometwo' />
                      </li>
                    </ul>
                  </div>
                </div>
                <div class='resultbox'>
                  <span class='text'>小計</span>
                  <span class='number totalincome' />
                  <span class='text'>元</span>
                </div>
              </div>
              <div class='expenditurebox'>
                <div class='calbox'>
                  <div class='left'>
                    <span>支出狀況</span>
                  </div>
                  <div class='right'>
                    <div class='info'>
                      <ul>
                        <li>
                          <span class='text one'>房貸/房租支出</span>
                          <span class='number one' data-id='1' />
                          <span class='text two'>元/月，剩餘年度</span>
                          <span class='number two' data-id='1' />
                          <span class='text three'>年</span>
                        </li>
                        <li>
                          <span class='text one'>車貸支出</span>
                          <span class='number one' data-id='2' />
                          <span class='text two'>元/月，剩餘年度</span>
                          <span class='number two' data-id='2' />
                          <span class='text three'>年</span>
                        </li>
                        <li>
                          <span class='text one'>其他貸款</span>
                          <span class='number one' data-id='3' />
                          <span class='text two'>元/月，剩餘年度</span>
                          <span class='number two' data-id='3' />
                          <span class='text three'>年</span>
                        </li>
                        <li>
                          <span class='text one'>離退休生活平均月支出</span>
                          <span class='number one' data-id='4' />
                          <span class='text two'>元/月，剩餘年度</span>
                          <span class='number two' data-id='4' />
                          <span class='text three'>年</span>
                        </li>
                        <li>
                          <span class='text one'>教育費用支出</span>
                          <span class='number one' data-id='5' />
                          <span class='text two'>元/月，剩餘年度</span>
                          <span class='number two' data-id='5' />
                          <span class='text three'>年</span>
                        </li>
                      </ul>
                    </div>
                    <div class='chartbox'>
                      <div class='expendituretitle'>
                        <span>您的保障需求</span>
                      </div>
                      <div class='chartleft'>
                        <div class='totalpricebox'>
                          <ul>
                            <li class='text'>
                              <span>不含月生活支出</span>
                              <span class='price excludeprice' />
                            </li>
                            <li class='unittext'>
                              <span class='unit'>元/年</span>
                            </li>
                            <li class='text'>
                              <span>含月生活支出</span>
                              <span class='price includeprice' />
                            </li>
                            <li class='unittext'>
                              <span class='unit'>元/年</span>
                            </li>
                          </ul>
                        </div>
                        <div class='colorbox'>
                          <ul class='colorlist'>
                            <li class='first'>
                              <i class='one' />
                              <span>房貸/房租支出</span>
                            </li>
                            <li>
                              <i class='two' />
                              <span>車貸支出</span>
                            </li>
                            <li>
                              <i class='three' />
                              <span>其他貸款</span>
                            </li>
                            <li>
                              <i class='four' />
                              <span>退休生活支出</span>
                            </li>
                            <li class='last'>
                              <i class='five' />
                              <span>教育費用支出</span>
                            </li>
                          </ul>
                        </div>
                        <div class='totalinfobox'>
                          <ul>
                            <li>
                              <span class='text'>壽險保障需求</span>
                              <span class='price life' />
                              <span class='unit'>元/年</span>
                            </li>
                            <li>
                              <span class='text'>
                                每個月收入 - 支出餘額
                              </span>
                              <span class='price inandout' />
                              <span class='unit'>元/月</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class='chartright'>
                        <canvas id='pdfcanvas' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class='hospitalizebox'>
                <div class='calbox'>
                  <div class='left'>
                    <span>住院日額</span>
                  </div>
                  <div class='right'>
                    <ul>
                      <li>
                        <span class='title'>已投保住院日額</span>
                        <span class='price one' />
                        <span class='unit'>元/日</span>
                      </li>
                      <li>
                        <span class='title'>選擇居住第主要醫院 </span>
                        <span class='price two' />
                        <span class='unit'>元/日</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class='resultbox'>
                  <span class='text'>尚需補強</span>
                  <span class='number' />
                  <span class='unit'>元/日</span>
                </div>
              </div>
              <div class='longtermcarebox'>
                <div class='calbox'>
                  <div class='left'>
                    <span>長照&失能需求</span>
                  </div>
                  <div class='right'>
                    <ul class='longtermcaretop'>
                      <li>
                        <span class='title'>預估長照或失能月支出</span>
                        <span class='price' />
                        <span class='unit'>元/月</span>
                      </li>
                    </ul>
                    <ul class='longtermcarebottom'>
                      <li>
                        <span class='title'>社會補助</span>
                        <span class='price one' />
                        <span class='unit'>元/月</span>
                      </li>
                      <li>
                        <span class='title'>自購商業保險</span>
                        <span class='price two' />
                        <span class='unit'>元/月</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class='resultbox'>
                  <span class='text'>尚需補強</span>
                  <span class='number' />
                  <span class='unit'>元/月</span>
                </div>
              </div>
              <div class='retirebox'>
                <div class='calbox'>
                  <div class='left'>
                    <span>退休生活</span>
                  </div>
                  <div class='right'>
                    <div class='retiretop'>
                      <span class='text'>預估退休年齡</span>
                      <span class='price one' />
                      <span class='text'>歲，預估退休後餘命</span>
                      <span class='price two' />
                      <span class='text'>年</span>
                    </div>
                    <ul class='retiremiddle'>
                      <li>
                        <span class='title'>預估退休後月支出</span>
                        <span class='price one' />
                        <span class='unit'>元</span>
                      </li>
                      <li>
                        <span class='title'>勞保每月給付</span>
                        <span class='price two' />
                        <span class='unit'>元</span>
                      </li>
                    </ul>
                    <ul class='retirebottom'>
                      <li>
                        <span class='title'>商業保險每月給付</span>
                        <span class='price one' />
                        <span class='unit'>元</span>
                      </li>
                      <li>
                        <span class='title'>其他每月收入</span>
                        <span class='price two' />
                        <span class='unit'>元</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class='resultbox'>
                  <span class='text'>退休後每月尚差</span>
                  <span class='number' />
                  <span class='unit'>元</span>
                </div>
              </div>
            </div>
            <div class='bottombox'>
              <ul>
                <li>
                  <div class='title'>
                    <span>台北辦公室</span>
                  </div>
                  <div class='address'>
                    <span class='text'>地址：</span>
                    <span class='content'>
                      11268台北市北投區大業路136號5樓
                    </span>
                  </div>
                  <div class='phone'>
                    <span class='text'>電話：</span>
                    <span class='content'>02-2898-1999</span>
                  </div>
                </li>
                <li>
                  <div class='title'>
                    <span>台南辦公室</span>
                  </div>
                  <div class='address'>
                    <span class='text'>地址：</span>
                    <span class='content'>
                      71079 台南市永康區中華二路350號2樓
                    </span>
                  </div>
                  <div class='phone'>
                    <span class='text'>電話：</span>
                    <span class='content'>06-208-3119</span>
                  </div>
                </li>
                <li>
                  <div class='fbblock'>
                    <div class='blockleft'>
                      <div class='top'>
                        <div class='imgbox'>
                          <img
                            alt=''
                            src={`${
                              VC_CONFIG.INDEX_URL
                            }/wp-content/themes/cec/assets/img/cibc/pdf/icon.png`}
                          />
                        </div>
                        <span>加入好友</span>
                      </div>
                      <div class='bottom'>
                        <span>
                          若有任何疑問，歡迎掃描上方QRCODE，可立即與我們聯絡唷！
                        </span>
                      </div>
                    </div>
                    <div class='blockright'>
                      <img
                        alt=''
                        src={`${
                          VC_CONFIG.INDEX_URL
                        }/wp-content/themes/cec/assets/img/cibc/pdf/qrcodeicon.png`}
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class='mark'>
              <span>保險經紀人 E-mail : TW_CIBC@uni-prosperity.com.tw</span>
            </div>
          </div>
        </div>
      </main>
    )
  }
}

// 編輯器
export class CibcCalculationEditor extends Component {
  render() {
    return (
      <div className='vu-blocks-editor'>
        <div class='components-placeholder__label'>
          <span class='block-editor-block-icon'>
            <div alt='f538' class='dashicons dashicons-layout' />
          </span>
          保障試算
        </div>
      </div>
    );
  }
}

function DateonChange(date, dateString) {
  var tmpYear, tmpSelectYear, tmpSelectMonth, tmpSelectDay, tmpDifference;
  var tmpNowYear = moment().format('YYYY');
  var tmpNowMonth = moment().format('MM');
  var tmpNowDay = moment().format('DD');
  $('[name="averageprice"]').attr('disabled', false);
  tmpSelectYear = moment(date).format('YYYY');
  tmpSelectMonth = moment(date).format('MM');
  tmpSelectDay = moment(date).format('DD');
  if (tmpNowYear == tmpSelectYear) {
    tmpDifference = parseInt(tmpNowMonth, 10) - parseInt(tmpSelectMonth, 10);
    if (Math.abs(tmpDifference) < 6) {
      tmpYear = 0;
    } else {
      tmpYear = 1;
    }
  } else if (tmpNowYear > tmpSelectYear) {
    if (tmpNowMonth > 6 && tmpSelectMonth <= 6) {
      tmpDifference = parseInt(tmpNowMonth, 10) - parseInt(tmpSelectMonth, 10);
      if (Math.abs(tmpDifference) <= 6) {
        tmpYear = tmpNowYear - tmpSelectYear;
      } else {
        tmpYear = tmpNowYear - tmpSelectYear + 1;
      }
    } else if (tmpNowMonth > 6 && tmpSelectMonth > 6) {
      tmpDifference = parseInt(tmpNowMonth, 10) - parseInt(tmpSelectMonth, 10);
      if (Math.abs(tmpDifference) <= 6) {
        tmpYear = tmpNowYear - tmpSelectYear;
      } else {
        tmpYear = tmpNowYear - tmpSelectYear + 1;
      }
    } else if (tmpNowMonth <= 6 && tmpSelectMonth <= 6) {
      tmpDifference = parseInt(tmpNowMonth, 10) - parseInt(tmpSelectMonth, 10);
      if (Math.abs(tmpDifference) <= 6) {
        tmpYear = tmpNowYear - tmpSelectYear;
      } else {
        tmpYear = tmpNowYear - tmpSelectYear + 1;
      }
    } else if (tmpNowMonth <= 6 && tmpSelectMonth > 6) {
      tmpDifference =
        parseInt(tmpNowMonth, 10) + 12 - parseInt(tmpSelectMonth, 10);
      if (Math.abs(tmpDifference) <= 6) {
        tmpYear = tmpNowYear - tmpSelectYear - 1;
      } else {
        tmpYear = tmpNowYear - tmpSelectYear;
      }
    } else {
      tmpYear = tmpNowYear - tmpSelectYear;
    }
  } else {
    tmpYear = 0;
  }

  var tmpDiff = null;
  if (tmpYear > 65) {
    tmpDiff = 0;
  } else {
    tmpDiff = 65 - tmpYear;
  }
  $(
    '.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age'
  ).html(tmpYear);
  $(
    '.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.year'
  ).html(tmpDiff);

  $('#averageyear').text(tmpDiff);
}

//////////////////////////////////////////////
const cibcCalculationDidMount = () => {
  window.onload = function() {
    var tab_li = document.getElementsByTagName('g');
    for (let i = 0; i < tab_li.length; i++) {
      tab_li[i].index = i;
      tab_li[i].onclick = function() {
        //var content = document.getElementById(this.id + "_stores");
        var content_remove;
        for (let j = 0; j < tab_li.length; j++) {
          content_remove = document.getElementById(tab_li[j].id + '_stores');
          tab_li[j].classList.remove('active');
          $("[id$='_stores']").attr('style', 'display:none');
        }
        this.setAttribute('class', ' area active');
        $('#' + this.id + '_stores').show();
      };
    }
  };
  $(document).ready(function() {
    //$(function () {
    equalHeight();
    //});
  });
  $(window).resize(function() {
    equalHeight();
  });

  function equalHeight() {
    var tmpTitle = $('.wrapper.cibc-cal   .contentbox .blocktitle');
    var tmpTitleHeight = tmpTitle.find('span').height();
    tmpTitle.find('.hr').css({ height: tmpTitleHeight });
    var tmpArray = [];
    var tmpArraytwo = [];
    if (window.innerWidth > 1024) {
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .row-comment ul li'
      ).css({ height: 'auto' });
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .row-comment ul li'
      ).css({ height: 'auto' });
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .row-comment ul li'
      ).each(function(index) {
        var tmpHeight = $(this)
          .find('.input')
          .height();
        tmpArray.push(tmpHeight);
      });
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .row-comment ul li'
      ).css({ height: Math.max.apply(null, tmpArray) - 2 + 'px' });
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .row-comment ul li'
      ).each(function(index) {
        var tmpHeight = $(this)
          .find('.input')
          .height();
        tmpArraytwo.push(tmpHeight);
      });
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .row-comment ul li'
      ).css({ height: Math.max.apply(null, tmpArraytwo) - 2 + 'px' });
    }
  }

  // 在Array指定位置塞值
  Array.prototype.insert = function(index, item) {
    this.splice(index, 0, item);
  };
  function getChart(
    mortgageprice,
    mortgageyear,
    carloanprice,
    carloanyear,
    otherloansprice,
    otherloansyear,
    averageprice,
    averageyear,
    eduprice,
    eduyear
  ) {
    $(
      '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
    )
      .removeClass('none')
      .find('.chartbox')
      .html('<canvas id="canvas"></canvas>');
    var tmpAge = $(
      '.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age'
    ).text();
    var tmpArrayTotal = [];
    var tmpArrayTotalLinePrice = [];
    var tmpArrayTotalLineYear = [];
    var tmpArrayone = [];
    var tmpArraytwo = [];
    var tmpArraythree = [];
    var tmpArrayfour = [];
    var tmpArrayfive = [];
    var tmpJson = [];
    var tmpArrayYear = [];
    var tmpNewArrayYear = [];
    var tmpNewArrayCalYear = [];
    var tmpMortgageOneYear = parseInt(mortgageprice, 10) * 12;
    var tmpMortgageTotal = 0;
    var tmpCarloanOneYear = parseInt(carloanprice, 10) * 12;
    var tmpCarloanTotal = 0;
    var tmpOtherloansOneYear = parseInt(otherloansprice, 10) * 12;
    var tmpOtherloansTotal = 0;
    var tmpAverageOneYear = parseInt(averageprice, 10) * 12;
    var tmpAverageTotal = 0;
    var tmpEduOneYear = parseInt(eduprice, 10) * 12;
    var tmpEduTotal = 0;

    if (parseInt(mortgageprice, 10) > 0) {
      tmpJson.push({
        type: 'mortgage',
        price: parseInt(mortgageprice, 10),
        year: parseInt(mortgageyear, 10),
      });
    }
    if (parseInt(carloanprice, 10) > 0) {
      tmpJson.push({
        type: 'carloan',
        price: parseInt(carloanprice, 10),
        year: parseInt(carloanyear, 10),
      });
    }
    if (parseInt(otherloansprice, 10) > 0) {
      tmpJson.push({
        type: 'otherloans',
        price: parseInt(otherloansprice, 10),
        year: parseInt(otherloansyear, 10),
      });
    }
    if (parseInt(averageprice, 10) > 0) {
      tmpJson.push({
        type: 'average',
        price: parseInt(averageprice, 10),
        year: parseInt(averageyear, 10),
      });
    }
    if (parseInt(eduprice, 10) > 0) {
      tmpJson.push({
        type: 'edu',
        price: parseInt(eduprice, 10),
        year: parseInt(eduyear, 10),
      });
    }
    tmpJson = tmpJson.sort(function(a, b) {
      return a.year > b.year ? 1 : -1;
    });

    // x 軸標籤
    $.each(tmpJson, function(key, value) {
      // 總共線(藍) Begin
      if (value.price != 0 && value.year != 0) {
        tmpArrayTotalLinePrice.push(value.price);
        tmpArrayTotalLineYear.push(value.year);
      }
      // 總共線(藍) End
      tmpArrayYear.push(value.year);
    });
    tmpArrayYear.sort(sortNumberOther);

    for (var i = 0; i < tmpArrayYear.length; i++) {
      tmpNewArrayYear.push(
        parseInt(tmpAge, 10) + parseInt(tmpJson[i].year, 10) + '歲'
      );
      tmpNewArrayCalYear.push(
        parseInt(tmpAge, 10) + parseInt(tmpJson[i].year, 10)
      );
    }
    tmpNewArrayYear.insert(0, parseInt(tmpAge, 10) + '歲');
    tmpNewArrayYear = tmpNewArrayYear.filter(function(el, i, arr) {
      return arr.indexOf(el) === i;
    });
    tmpNewArrayCalYear = tmpNewArrayCalYear.filter(function(el, i, arr) {
      return arr.indexOf(el) === i;
    });
    tmpArrayYear.insert(0, 0);
    tmpNewArrayCalYear.insert(0, 0);

    // 判斷在ArrayYear的第幾個
    tmpAge = $(
      '.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age'
    ).text()
      ? $(
          '.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age'
        ).text()
      : 0;
    var mortgageIndex = tmpNewArrayCalYear.indexOf(
      parseInt(mortgageyear, 10) + parseInt(tmpAge, 10)
    );
    var carloanIndex = tmpNewArrayCalYear.indexOf(
      parseInt(carloanyear, 10) + parseInt(tmpAge, 10)
    );
    var otherloansIndex = tmpNewArrayCalYear.indexOf(
      parseInt(otherloansyear, 10) + parseInt(tmpAge, 10)
    );
    var averageIndex = tmpNewArrayCalYear.indexOf(
      parseInt(averageyear, 10) + parseInt(tmpAge, 10)
    );
    var eduIndex = tmpNewArrayCalYear.indexOf(
      parseInt(eduyear, 10) + parseInt(tmpAge, 10)
    );

    // 房貸區塊
    if (mortgageIndex > 0 && mortgageprice && mortgageyear) {
      var mortgageTotal =
        parseInt(tmpMortgageOneYear, 10) * parseInt(mortgageyear, 10);
      tmpArrayone.push(mortgageTotal);
      for (let i = 0; i < mortgageIndex; i++) {
        var j = i + 1;
        var mortgageMount =
          mortgageTotal -
          parseInt(tmpMortgageOneYear, 10) *
            (tmpNewArrayCalYear[j] - parseInt(tmpAge, 10));
        tmpArrayone.push(mortgageMount);
      }
      tmpArrayone.sort(sortNumber);
      if (mortgageIndex == 1) {
        for (let i = 0; i < 4; i++) {
          tmpArrayone.push(0);
        }
      } else if (mortgageIndex == 2) {
        for (let i = 0; i < 3; i++) {
          tmpArrayone.push(0);
        }
      } else if (mortgageIndex == 3) {
        for (let i = 0; i < 2; i++) {
          tmpArrayone.push(0);
        }
      } else if (mortgageIndex == 4) {
        for (let i = 0; i < 1; i++) {
          tmpArrayone.push(0);
        }
      }
    }
    // 車貸區塊
    if (carloanIndex > 0 && carloanprice && carloanyear) {
      var carloanTotal =
        parseInt(tmpCarloanOneYear, 10) * parseInt(carloanyear, 10);
      tmpArraytwo.push(carloanTotal);
      for (let i = 0; i < carloanIndex; i++) {
        let j = i + 1;
        var carloanMount =
          carloanTotal -
          parseInt(tmpCarloanOneYear, 10) *
            (tmpNewArrayCalYear[j] - parseInt(tmpAge, 10));
        tmpArraytwo.push(carloanMount);
      }
      tmpArraytwo.sort(sortNumber);
      if (carloanIndex == 1) {
        for (let i = 0; i < 4; i++) {
          tmpArraytwo.push(0);
        }
      } else if (carloanIndex == 2) {
        for (let i = 0; i < 3; i++) {
          tmpArraytwo.push(0);
        }
      } else if (carloanIndex == 3) {
        for (let i = 0; i < 2; i++) {
          tmpArraytwo.push(0);
        }
      } else if (carloanIndex == 4) {
        for (let i = 0; i < 1; i++) {
          tmpArraytwo.push(0);
        }
      }
    }
    // 其他貸款區塊
    if (otherloansIndex > 0 && otherloansprice && otherloansyear) {
      var otherloansTotal =
        parseInt(tmpOtherloansOneYear, 10) * parseInt(otherloansyear, 10);
      tmpArraythree.push(otherloansTotal);
      for (let i = 0; i < otherloansIndex; i++) {
        let j = i + 1;
        var otherloansMount =
          otherloansTotal -
          parseInt(tmpOtherloansOneYear, 10) *
            (tmpNewArrayCalYear[j] - parseInt(tmpAge, 10));
        tmpArraythree.push(otherloansMount);
      }
      tmpArraythree.sort(sortNumber);
      if (otherloansIndex == 1) {
        for (let i = 0; i < 4; i++) {
          tmpArraythree.push(0);
        }
      } else if (otherloansIndex == 2) {
        for (let i = 0; i < 3; i++) {
          tmpArraythree.push(0);
        }
      } else if (otherloansIndex == 3) {
        for (let i = 0; i < 2; i++) {
          tmpArraythree.push(0);
        }
      } else if (otherloansIndex == 4) {
        for (let i = 0; i < 1; i++) {
          tmpArraythree.push(0);
        }
      }
    }
    // 平均支出區塊
    if (averageIndex > 0 && averageprice && averageyear) {
      var averageTotal =
        parseInt(tmpAverageOneYear, 10) * parseInt(averageyear, 10);
      tmpArrayfour.push(averageTotal);
      for (let i = 0; i < averageIndex; i++) {
        let j = i + 1;
        var averageMount =
          averageTotal -
          parseInt(tmpAverageOneYear, 10) *
            (tmpNewArrayCalYear[j] - parseInt(tmpAge, 10));
        tmpArrayfour.push(averageMount);
      }
      tmpArrayfour.sort(sortNumber);
      if (averageIndex == 1) {
        for (let i = 0; i < 4; i++) {
          tmpArrayfour.push(0);
        }
      } else if (averageIndex == 2) {
        for (let i = 0; i < 3; i++) {
          tmpArrayfour.push(0);
        }
      } else if (averageIndex == 3) {
        for (let i = 0; i < 2; i++) {
          tmpArrayfour.push(0);
        }
      } else if (averageIndex == 4) {
        for (let i = 0; i < 1; i++) {
          tmpArrayfour.push(0);
        }
      }
    }
    // 教育費用區塊
    if (eduIndex > 0 && eduprice && eduyear) {
      var eduTotal = parseInt(tmpEduOneYear, 10) * parseInt(eduyear, 10);
      tmpArrayfive.push(eduTotal);
      for (let i = 0; i < eduIndex; i++) {
        let j = i + 1;
        var eduMount =
          eduTotal -
          parseInt(tmpEduOneYear, 10) *
            (tmpNewArrayCalYear[j] - parseInt(tmpAge, 10));
        tmpArrayfive.push(eduMount);
      }
      tmpArrayfive.sort(sortNumber);
      if (eduIndex == 1) {
        for (let i = 0; i < 4; i++) {
          tmpArrayfive.push(0);
        }
      } else if (eduIndex == 2) {
        for (let i = 0; i < 3; i++) {
          tmpArrayfive.push(0);
        }
      } else if (eduIndex == 3) {
        for (let i = 0; i < 2; i++) {
          tmpArrayfive.push(0);
        }
      } else if (eduIndex == 4) {
        for (let i = 0; i < 1; i++) {
          tmpArrayfive.push(0);
        }
      }
    }
    for (let i = 0; i < tmpNewArrayCalYear.length; i++) {
      var tmpTotalOne = tmpArrayone[i] ? tmpArrayone[i] : 0;
      var tmpTotalTwo = tmpArraytwo[i] ? tmpArraytwo[i] : 0;
      var tmpTotalThree = tmpArraythree[i] ? tmpArraythree[i] : 0;
      var tmpTotalFour = tmpArrayfour[i] ? tmpArrayfour[i] : 0;
      var tmpTotalFive = tmpArrayfive[i] ? tmpArrayfive[i] : 0;
      var tmpTotal =
        tmpTotalOne + tmpTotalTwo + tmpTotalThree + tmpTotalFour + tmpTotalFive;
      tmpArrayTotal.push(tmpTotal);
    }
    if (tmpArrayTotal.length > 0) {
      $('#lifeinsuranceprice').text(addCommas(tmpArrayTotal[0]));
    }
    var chartData = {
      labels: tmpNewArrayYear,
      datasets: [
        {
          type: 'line',
          label: '總和',
          borderColor: '#0071bc',
          borderWidth: 2,
          fill: false,
          data: tmpArrayTotal,
        },
        {
          type: 'bar',
          label: '房貸/房租支出',
          backgroundColor: '#419ef2',
          data: tmpArrayone,
        },
        {
          type: 'bar',
          label: '車貸支出',
          backgroundColor: '#de4740',
          data: tmpArraytwo,
        },
        {
          type: 'bar',
          label: '其他貸款',
          backgroundColor: '#fcaf38',
          data: tmpArraythree,
        },
        {
          type: 'bar',
          label: '退休生活支出',
          backgroundColor: '#87d6d8',
          data: tmpArrayfour,
        },
        {
          type: 'bar',
          label: '教育費用支出',
          backgroundColor: '#f978a0',
          data: tmpArrayfive,
        },
      ],
    };

    var ctx = document.getElementById('canvas').getContext('2d');
    var ctxpdf = document.getElementById('pdfcanvas').getContext('2d');

    // window.myBar = new Chart(ctx, {
    //   type: 'bar',
    //   data: chartData,
    //   options: {
    //     legend: {
    //       display: false,
    //     },
    //     title: {
    //       display: false,
    //     },
    //     tooltips: {
    //       mode: 'index',
    //       intersect: false,
    //       enabled: true,
    //       callbacks: {
    //         label: function(tooltipItem, data) {
    //           var tmpLabel = data.datasets[tooltipItem.datasetIndex].label;
    //           var tooltipValue =
    //             data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
    //           return tmpLabel + ':' + parseInt(tooltipValue).toLocaleString();
    //         },
    //       },
    //     },
    //     responsive: true,
    //     scales: {
    //       xAxes: [
    //         {
    //           scaleLabel: {
    //             display: true,
    //             labelString: '歲',
    //             fontStyle: 'bold',
    //             fontColor: '#251b1b',
    //             fontSize: 16,
    //             fontFamily: "'cwTeXYen', sans-serif",
    //           },
    //           stacked: true,
    //           barPercentage: 0.35,
    //           ticks: {
    //             fontColor: '#251b1b',
    //             fontSize: 16,
    //             fontFamily: "'cwTeXYen', sans-serif",
    //           },
    //         },
    //       ],
    //       yAxes: [
    //         {
    //           scaleLabel: {
    //             display: true,
    //             labelString: '支出',
    //             fontStyle: 'bold',
    //             fontColor: '#251b1b',
    //             fontSize: 16,
    //             fontFamily: "'cwTeXYen', sans-serif",
    //           },
    //           stacked: true,
    //           ticks: {
    //             fontColor: '#251b1b',
    //             fontSize: 16,
    //             fontFamily: "'cwTeXYen', sans-serif",
    //             callback: function(value, index, values) {
    //               if (parseInt(value) >= 1000) {
    //                 return value
    //                   .toString()
    //                   .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    //               } else {
    //                 return value;
    //               }
    //             },
    //           },
    //         },
    //       ],
    //     },
    //   },
    // });
    // $('#printcibxblock').removeClass('none');
    // window.myBar = new Chart(ctxpdf, {
    //   type: 'bar',
    //   data: chartData,
    //   options: {
    //     legend: {
    //       display: false,
    //     },
    //     title: {
    //       display: false,
    //     },
    //     tooltips: {
    //       mode: 'index',
    //       intersect: false,
    //       enabled: true,
    //       callbacks: {
    //         label: function(tooltipItem, data) {
    //           var value = data.datasets[0].data[tooltipItem.index];
    //           if (parseInt(value) >= 1000) {
    //             return (
    //               '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    //             );
    //           } else {
    //             return '$' + value;
    //           }
    //         },
    //       },
    //     },
    //     responsive: true,
    //     scales: {
    //       xAxes: [
    //         {
    //           scaleLabel: {
    //             display: false,
    //             labelString: '歲',
    //             fontStyle: 'bold',
    //             fontColor: '#251b1b',
    //             fontSize: 16,
    //             fontFamily: "'cwTeXYen', sans-serif",
    //           },
    //           stacked: true,
    //           barPercentage: 0.35,
    //           ticks: {
    //             fontColor: '#251b1b',
    //             fontSize: 16,
    //             fontFamily: "'cwTeXYen', sans-serif",
    //           },
    //         },
    //       ],
    //       yAxes: [
    //         {
    //           scaleLabel: {
    //             display: false,
    //             labelString: '支出',
    //             fontStyle: 'bold',
    //             fontColor: '#251b1b',
    //             fontSize: 16,
    //             fontFamily: "'cwTeXYen', sans-serif",
    //           },
    //           stacked: true,
    //           ticks: {
    //             fontColor: '#251b1b',
    //             fontSize: 16,
    //             fontFamily: "'cwTeXYen', sans-serif",
    //             callback: function(value, index, values) {
    //               if (parseInt(value) >= 1000) {
    //                 return value
    //                   .toString()
    //                   .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    //               } else {
    //                 return value;
    //               }
    //             },
    //           },
    //         },
    //       ],
    //     },
    //   },
    // });
    // $('#printcibxblock').addClass('none');
  }
  function drawChart(
    dataMortgagePrice,
    dataMortgageYear,
    dataCarloanPrice,
    dataCarloanYear,
    dataOtherloansPrice,
    dataOtherloansYear,
    dataAveragePrice,
    dataAverageYear,
    dataEduPrice,
    dataEduYear
  ) {
    var tmpStableIncome = $('[name="stableincome"]').val()
      ? clearCommas($('[name="stableincome"]').val())
      : 0;
    var tmpOtherIncome = $('[name="otherincome"]').val()
      ? clearCommas($('[name="otherincome"]').val())
      : 0;
    var tmpMortgagePriceVal = dataMortgagePrice.val()
      ? clearCommas(dataMortgagePrice.val())
      : 0;
    var tmpMortgageYearVal = dataMortgageYear.val()
      ? dataMortgageYear.val()
      : 0;
    var tmpCarloanPriceVal = dataCarloanPrice.val()
      ? clearCommas(dataCarloanPrice.val())
      : 0;
    var tmpCarloanYearVal = dataCarloanYear.val() ? dataCarloanYear.val() : 0;
    var tmpOtherloansPriceVal = dataOtherloansPrice.val()
      ? clearCommas(dataOtherloansPrice.val())
      : 0;
    var tmpOtherloansYearVal = dataOtherloansYear.val()
      ? dataOtherloansYear.val()
      : 0;
    var tmpAveragePriceVal = null;
    if (dataAveragePrice) {
      tmpAveragePriceVal = dataAveragePrice.val()
        ? clearCommas(dataAveragePrice.val())
        : 0;
    } else {
      tmpAveragePriceVal = 0;
    }
    var tmpAverageYearVal = dataAverageYear.text() ? dataAverageYear.text() : 0;
    var tmpEduPriceVal = dataEduPrice.val()
      ? clearCommas(dataEduPrice.val())
      : 0;
    var tmpEduYearVal = dataEduYear.val() ? dataEduYear.val() : 0;
    var tmpTotalPrice =
      parseInt(tmpMortgagePriceVal, 10) +
      parseInt(tmpCarloanPriceVal, 10) +
      parseInt(tmpOtherloansPriceVal, 10) +
      parseInt(tmpAveragePriceVal, 10) +
      parseInt(tmpEduPriceVal, 10);
    var tmpInAndOutcomePrice =
      parseInt(tmpStableIncome, 10) +
      parseInt(tmpOtherIncome, 10) -
      parseInt(tmpTotalPrice, 10);
    if (
      tmpMortgagePriceVal == 0 &&
      tmpMortgageYearVal == 0 &&
      tmpCarloanPriceVal == 0 &&
      tmpCarloanYearVal == 0 &&
      tmpOtherloansPriceVal == 0 &&
      tmpOtherloansYearVal == 0 &&
      tmpAveragePriceVal == 0 &&
      tmpAverageYearVal == 0 &&
      tmpEduPriceVal == 0 &&
      tmpEduYearVal == 0
    ) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
      ).addClass('none');
    } else {
      getChart(
        tmpMortgagePriceVal,
        tmpMortgageYearVal,
        tmpCarloanPriceVal,
        tmpCarloanYearVal,
        tmpOtherloansPriceVal,
        tmpOtherloansYearVal,
        tmpAveragePriceVal,
        tmpAverageYearVal,
        tmpEduPriceVal,
        tmpEduYearVal
      );
    }
    if (tmpInAndOutcomePrice < 0) {
      $('#inandoutcomeprice')
        .text(addCommas(tmpInAndOutcomePrice))
        .addClass('red');
    } else {
      $('#inandoutcomeprice')
        .text(addCommas(tmpInAndOutcomePrice))
        .removeClass('red');
    }
  }
  // 倒排序
  function sortNumber(a, b) {
    return b - a;
  }
  // 正排序
  function sortNumberOther(a, b) {
    return a - b;
  }
  // 加價錢的逗號
  function addCommas(num) {
    var aIntNum = num.toString().split('.');
    var iIntPart = aIntNum[0];
    var iFlootPart = aIntNum.length > 1 ? '.' + aIntNum[1] : '';
    var rgx = /(\d+)(\d{3})/;
    if (iIntPart.length >= 4) {
      while (rgx.test(iIntPart)) {
        iIntPart = iIntPart.replace(rgx, '$1,$2');
      }
    }
    return iIntPart + iFlootPart;
  }

  // 去除逗號
  function clearCommas(str) {
    if (str) {
      str = str.replace(/,/g, '');
      return str;
    } else {
      return 0;
    }
  }

  var tmpStableIncome = $('[name="stableincome"]');
  var tmpOtherIncome = $('[name="otherincome"]');
  var tmpMortgagePrice = $('[name="mortgageprice"]');
  var tmpMortgageYear = $('[name="mortgageyear"]');
  var tmpCarloanPrice = $('[name="carloanprice"]');
  var tmpCarloanYear = $('[name="carloanyear"]');
  var tmpOtherloansPrice = $('[name="otherloansprice"]');
  var tmpOtherloansYear = $('[name="otherloansyear"]');
  var tmpAveragePrice = $('[name="averageprice"]');
  var tmpAverageYear = $('#averageyear');
  var tmpEduPrice = $('[name="eduprice"]');
  var tmpEduYear = $('[name="eduyear"]');
  tmpStableIncome.keyup(function() {
    var tmpThisValue = clearCommas($(this).val());
    $(this).val(addCommas(tmpThisValue));
    var tmpStableIncomeValue = tmpStableIncome.val()
      ? clearCommas(tmpStableIncome.val())
      : 0;
    var tmpOtherIncomeValue = tmpOtherIncome.val()
      ? clearCommas(tmpOtherIncome.val())
      : 0;
    var tmpValue =
      parseInt(tmpStableIncomeValue, 10) + parseInt(tmpOtherIncomeValue, 10);
    var tmpMortgagePriceVal = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpCarloanPriceVal = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpOtherloansPriceVal = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpAveragePriceVal = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpEduPriceVal = tmpEduPrice.val() ? clearCommas(tmpEduPrice.val()) : 0;
    var tmpTotalPrice =
      parseInt(tmpMortgagePriceVal, 10) +
      parseInt(tmpCarloanPriceVal, 10) +
      parseInt(tmpOtherloansPriceVal, 10) +
      parseInt(tmpAveragePriceVal, 10) +
      parseInt(tmpEduPriceVal, 10);
    var tmpInAndOutcomePrice = tmpValue - parseInt(tmpTotalPrice, 10);
    $('.incomeblock .row-comment .resultbox .resultstr.incomemoney').html(
      addCommas(tmpValue)
    );
    if (tmpInAndOutcomePrice < 0) {
      $('#inandoutcomeprice')
        .text(addCommas(tmpInAndOutcomePrice))
        .addClass('red');
    } else {
      $('#inandoutcomeprice')
        .text(addCommas(tmpInAndOutcomePrice))
        .removeClass('red');
    }
  });
  tmpOtherIncome.keyup(function() {
    var tmpThisValue = clearCommas($(this).val());
    $(this).val(addCommas(tmpThisValue));
    var tmpStableIncomeValue = tmpStableIncome.val()
      ? clearCommas(tmpStableIncome.val())
      : 0;
    var tmpOtherIncomeValue = tmpOtherIncome.val()
      ? clearCommas(tmpOtherIncome.val())
      : 0;
    var tmpValue =
      parseInt(tmpStableIncomeValue, 10) + parseInt(tmpOtherIncomeValue, 10);
    var tmpMortgagePriceVal = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpCarloanPriceVal = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpOtherloansPriceVal = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpAveragePriceVal = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpEduPriceVal = tmpEduPrice.val() ? clearCommas(tmpEduPrice.val()) : 0;
    var tmpTotalPrice =
      parseInt(tmpMortgagePriceVal, 10) +
      parseInt(tmpCarloanPriceVal, 10) +
      parseInt(tmpOtherloansPriceVal, 10) +
      parseInt(tmpAveragePriceVal, 10) +
      parseInt(tmpEduPriceVal, 10);
    var tmpInAndOutcomePrice = tmpValue - parseInt(tmpTotalPrice, 10);
    $('.incomeblock .row-comment .resultbox .resultstr.incomemoney').html(
      addCommas(tmpValue)
    );
    if (tmpInAndOutcomePrice < 0) {
      $('#inandoutcomeprice')
        .text(addCommas(tmpInAndOutcomePrice))
        .addClass('red');
    } else {
      $('#inandoutcomeprice')
        .text(addCommas(tmpInAndOutcomePrice))
        .removeClass('red');
    }
  });
  tmpMortgagePrice.keyup(function() {
    var tmpThisValue = clearCommas($(this).val());
    $(this).val(addCommas(tmpThisValue));
    var tmpMortgagePriceText = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpMortgageYearText = tmpMortgageYear.val() ? tmpMortgageYear.val() : 0;
    var tmpCarloanPriceText = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpCarloanYearText = tmpCarloanYear.val() ? tmpCarloanYear.val() : 0;
    var tmpOtherloansPriceText = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpOtherloansYearText = tmpOtherloansYear.val()
      ? tmpOtherloansYear.val()
      : 0;
    var tmpAveragePriceText = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpAverageYearText = tmpAverageYear.text() ? tmpAverageYear.text() : 0;
    var tmpEduPriceText = tmpEduPrice.val()
      ? clearCommas(tmpEduPrice.val())
      : 0;
    var tmpEduYearText = tmpEduYear.val() ? tmpEduYear.val() : 0;
    var tmpTotalPriceText =
      parseInt(tmpMortgagePriceText, 10) +
      parseInt(tmpCarloanPriceText, 10) +
      parseInt(tmpOtherloansPriceText, 10) +
      parseInt(tmpAveragePriceText, 10) +
      parseInt(tmpEduPriceText, 10);
    var tmpTotalInclude =
      parseInt(tmpMortgagePriceText, 10) *
        12 *
        parseInt(tmpMortgageYearText, 10) +
      parseInt(tmpCarloanPriceText, 10) *
        12 *
        parseInt(tmpCarloanYearText, 10) +
      parseInt(tmpOtherloansPriceText, 10) *
        12 *
        parseInt(tmpOtherloansYearText, 10) +
      parseInt(tmpAveragePriceText, 10) *
        12 *
        parseInt(tmpAverageYearText, 10) +
      parseInt(tmpEduPriceText, 10) * 12 * parseInt(tmpEduYearText, 10);
    var tmpTotalExclude =
      parseInt(tmpTotalInclude, 10) -
      parseInt(tmpAveragePriceText, 10) * 12 * parseInt(tmpAverageYearText, 10);
    var tmpThisPriceVal = tmpMortgagePrice.val();
    var tmpThisYearVal = tmpMortgageYear.val();
    if (tmpThisPriceVal && tmpThisYearVal) {
      drawChart(
        tmpMortgagePrice,
        tmpMortgageYear,
        tmpCarloanPrice,
        tmpCarloanYear,
        tmpOtherloansPrice,
        tmpOtherloansYear,
        tmpAveragePrice,
        tmpAverageYear,
        tmpEduPrice,
        tmpEduYear
      );
    } else if (
      tmpMortgagePriceText == 0 &&
      tmpCarloanPriceText == 0 &&
      tmpOtherloansPriceText == 0 &&
      tmpAveragePriceText == 0 &&
      tmpEduPriceText == 0
    ) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
      ).addClass('none');
    }
    $('#includeprice').html(addCommas(tmpTotalInclude));
    $('#excludeprice').html(addCommas(tmpTotalExclude));

    if (tmpTotalInclude <= 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(0);
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(addCommas(tmpTotalPriceText));
    }
  });
  tmpMortgageYear.keyup(function() {
    var tmpMortgagePriceText = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpMortgageYearText = tmpMortgageYear.val() ? tmpMortgageYear.val() : 0;
    var tmpCarloanPriceText = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpCarloanYearText = tmpCarloanYear.val() ? tmpCarloanYear.val() : 0;
    var tmpOtherloansPriceText = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpOtherloansYearText = tmpOtherloansYear.val()
      ? tmpOtherloansYear.val()
      : 0;
    var tmpAveragePriceText = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpAverageYearText = tmpAverageYear.text() ? tmpAverageYear.text() : 0;
    var tmpEduPriceText = tmpEduPrice.val()
      ? clearCommas(tmpEduPrice.val())
      : 0;
    var tmpEduYearText = tmpEduYear.val() ? tmpEduYear.val() : 0;
    var tmpTotalPriceText =
      parseInt(tmpMortgagePriceText, 10) +
      parseInt(tmpCarloanPriceText, 10) +
      parseInt(tmpOtherloansPriceText, 10) +
      parseInt(tmpAveragePriceText, 10) +
      parseInt(tmpEduPriceText, 10);
    var tmpTotalInclude =
      parseInt(tmpMortgagePriceText, 10) *
        12 *
        parseInt(tmpMortgageYearText, 10) +
      parseInt(tmpCarloanPriceText, 10) *
        12 *
        parseInt(tmpCarloanYearText, 10) +
      parseInt(tmpOtherloansPriceText, 10) *
        12 *
        parseInt(tmpOtherloansYearText, 10) +
      parseInt(tmpAveragePriceText, 10) *
        12 *
        parseInt(tmpAverageYearText, 10) +
      parseInt(tmpEduPriceText, 10) * 12 * parseInt(tmpEduYearText, 10);
    var tmpTotalExclude =
      parseInt(tmpTotalInclude, 10) -
      parseInt(tmpAveragePriceText, 10) * 12 * parseInt(tmpAverageYearText, 10);
    var tmpThisPriceVal = tmpMortgagePrice.val();
    var tmpThisYearVal = tmpMortgageYear.val();
    if (tmpThisPriceVal && tmpThisYearVal) {
      drawChart(
        tmpMortgagePrice,
        tmpMortgageYear,
        tmpCarloanPrice,
        tmpCarloanYear,
        tmpOtherloansPrice,
        tmpOtherloansYear,
        tmpAveragePrice,
        tmpAverageYear,
        tmpEduPrice,
        tmpEduYear
      );
    } else if (
      tmpMortgagePriceText == 0 &&
      tmpCarloanPriceText == 0 &&
      tmpOtherloansPriceText == 0 &&
      tmpAveragePriceText == 0 &&
      tmpEduPriceText == 0
    ) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
      ).addClass('none');
    }
    $('#includeprice').html(addCommas(tmpTotalInclude));
    $('#excludeprice').html(addCommas(tmpTotalExclude));
    if (tmpTotalInclude <= 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(0);
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(addCommas(tmpTotalPriceText));
    }
  });
  tmpCarloanPrice.keyup(function() {
    var tmpThisValue = clearCommas($(this).val());
    $(this).val(addCommas(tmpThisValue));
    var tmpMortgagePriceText = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpMortgageYearText = tmpMortgageYear.val() ? tmpMortgageYear.val() : 0;
    var tmpCarloanPriceText = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpCarloanYearText = tmpCarloanYear.val() ? tmpCarloanYear.val() : 0;
    var tmpOtherloansPriceText = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpOtherloansYearText = tmpOtherloansYear.val()
      ? tmpOtherloansYear.val()
      : 0;
    var tmpAveragePriceText = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpAverageYearText = tmpAverageYear.text() ? tmpAverageYear.text() : 0;
    var tmpEduPriceText = tmpEduPrice.val()
      ? clearCommas(tmpEduPrice.val())
      : 0;
    var tmpEduYearText = tmpEduYear.val() ? tmpEduYear.val() : 0;
    var tmpTotalPriceText =
      parseInt(tmpMortgagePriceText, 10) +
      parseInt(tmpCarloanPriceText, 10) +
      parseInt(tmpOtherloansPriceText, 10) +
      parseInt(tmpAveragePriceText, 10) +
      parseInt(tmpEduPriceText, 10);
    var tmpTotalInclude =
      parseInt(tmpMortgagePriceText, 10) *
        12 *
        parseInt(tmpMortgageYearText, 10) +
      parseInt(tmpCarloanPriceText, 10) *
        12 *
        parseInt(tmpCarloanYearText, 10) +
      parseInt(tmpOtherloansPriceText, 10) *
        12 *
        parseInt(tmpOtherloansYearText, 10) +
      parseInt(tmpAveragePriceText, 10) *
        12 *
        parseInt(tmpAverageYearText, 10) +
      parseInt(tmpEduPriceText, 10) * 12 * parseInt(tmpEduYearText, 10);
    var tmpTotalExclude =
      parseInt(tmpTotalInclude, 10) -
      parseInt(tmpAveragePriceText, 10) * 12 * parseInt(tmpAverageYearText, 10);

    var tmpThisPriceVal = tmpCarloanPrice.val();
    var tmpThisYearVal = tmpCarloanYear.val();
    if (tmpThisPriceVal && tmpThisYearVal) {
      drawChart(
        tmpMortgagePrice,
        tmpMortgageYear,
        tmpCarloanPrice,
        tmpCarloanYear,
        tmpOtherloansPrice,
        tmpOtherloansYear,
        tmpAveragePrice,
        tmpAverageYear,
        tmpEduPrice,
        tmpEduYear
      );
    } else if (
      tmpMortgagePriceText == 0 &&
      tmpCarloanPriceText == 0 &&
      tmpOtherloansPriceText == 0 &&
      tmpAveragePriceText == 0 &&
      tmpEduPriceText == 0
    ) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
      ).addClass('none');
    }
    $('#includeprice').html(addCommas(tmpTotalInclude));
    $('#excludeprice').html(addCommas(tmpTotalExclude));
    if (tmpTotalInclude <= 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(0);
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(addCommas(tmpTotalPriceText));
    }
  });
  tmpCarloanYear.keyup(function() {
    var tmpMortgagePriceText = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpMortgageYearText = tmpMortgageYear.val() ? tmpMortgageYear.val() : 0;
    var tmpCarloanPriceText = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpCarloanYearText = tmpCarloanYear.val() ? tmpCarloanYear.val() : 0;
    var tmpOtherloansPriceText = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpOtherloansYearText = tmpOtherloansYear.val()
      ? tmpOtherloansYear.val()
      : 0;
    var tmpAveragePriceText = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpAverageYearText = tmpAverageYear.text() ? tmpAverageYear.text() : 0;
    var tmpEduPriceText = tmpEduPrice.val()
      ? clearCommas(tmpEduPrice.val())
      : 0;
    var tmpEduYearText = tmpEduYear.val() ? tmpEduYear.val() : 0;
    var tmpTotalPriceText =
      parseInt(tmpMortgagePriceText, 10) +
      parseInt(tmpCarloanPriceText, 10) +
      parseInt(tmpOtherloansPriceText, 10) +
      parseInt(tmpAveragePriceText, 10) +
      parseInt(tmpEduPriceText, 10);
    var tmpTotalInclude =
      parseInt(tmpMortgagePriceText, 10) *
        12 *
        parseInt(tmpMortgageYearText, 10) +
      parseInt(tmpCarloanPriceText, 10) *
        12 *
        parseInt(tmpCarloanYearText, 10) +
      parseInt(tmpOtherloansPriceText, 10) *
        12 *
        parseInt(tmpOtherloansYearText, 10) +
      parseInt(tmpAveragePriceText, 10) *
        12 *
        parseInt(tmpAverageYearText, 10) +
      parseInt(tmpEduPriceText, 10) * 12 * parseInt(tmpEduYearText, 10);
    var tmpTotalExclude =
      parseInt(tmpTotalInclude, 10) -
      parseInt(tmpAveragePriceText, 10) * 12 * parseInt(tmpAverageYearText, 10);
    var tmpThisPriceVal = tmpCarloanPrice.val();
    var tmpThisYearVal = tmpCarloanYear.val();
    if (tmpThisPriceVal && tmpThisYearVal) {
      drawChart(
        tmpMortgagePrice,
        tmpMortgageYear,
        tmpCarloanPrice,
        tmpCarloanYear,
        tmpOtherloansPrice,
        tmpOtherloansYear,
        tmpAveragePrice,
        tmpAverageYear,
        tmpEduPrice,
        tmpEduYear
      );
    } else if (
      tmpMortgagePriceText == 0 &&
      tmpCarloanPriceText == 0 &&
      tmpOtherloansPriceText == 0 &&
      tmpAveragePriceText == 0 &&
      tmpEduPriceText == 0
    ) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
      ).addClass('none');
    }
    $('#includeprice').html(addCommas(tmpTotalInclude));
    $('#excludeprice').html(addCommas(tmpTotalExclude));
    if (tmpTotalInclude <= 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(0);
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(addCommas(tmpTotalPriceText));
    }
  });
  tmpOtherloansPrice.keyup(function() {
    var tmpThisValue = clearCommas($(this).val());
    $(this).val(addCommas(tmpThisValue));
    var tmpMortgagePriceText = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpMortgageYearText = tmpMortgageYear.val() ? tmpMortgageYear.val() : 0;
    var tmpCarloanPriceText = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpCarloanYearText = tmpCarloanYear.val() ? tmpCarloanYear.val() : 0;
    var tmpOtherloansPriceText = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpOtherloansYearText = tmpOtherloansYear.val()
      ? tmpOtherloansYear.val()
      : 0;
    var tmpAveragePriceText = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpAverageYearText = tmpAverageYear.text() ? tmpAverageYear.text() : 0;
    var tmpEduPriceText = tmpEduPrice.val()
      ? clearCommas(tmpEduPrice.val())
      : 0;
    var tmpEduYearText = tmpEduYear.val() ? tmpEduYear.val() : 0;
    var tmpTotalPriceText =
      parseInt(tmpMortgagePriceText, 10) +
      parseInt(tmpCarloanPriceText, 10) +
      parseInt(tmpOtherloansPriceText, 10) +
      parseInt(tmpAveragePriceText, 10) +
      parseInt(tmpEduPriceText, 10);
    var tmpTotalInclude =
      parseInt(tmpMortgagePriceText, 10) *
        12 *
        parseInt(tmpMortgageYearText, 10) +
      parseInt(tmpCarloanPriceText, 10) *
        12 *
        parseInt(tmpCarloanYearText, 10) +
      parseInt(tmpOtherloansPriceText, 10) *
        12 *
        parseInt(tmpOtherloansYearText, 10) +
      parseInt(tmpAveragePriceText, 10) *
        12 *
        parseInt(tmpAverageYearText, 10) +
      parseInt(tmpEduPriceText, 10) * 12 * parseInt(tmpEduYearText, 10);
    var tmpTotalExclude =
      parseInt(tmpTotalInclude, 10) -
      parseInt(tmpAveragePriceText, 10) * 12 * parseInt(tmpAverageYearText, 10);
    var tmpThisPriceVal = tmpOtherloansPrice.val();
    var tmpThisYearVal = tmpOtherloansYear.val();
    if (tmpThisPriceVal && tmpThisYearVal) {
      drawChart(
        tmpMortgagePrice,
        tmpMortgageYear,
        tmpCarloanPrice,
        tmpCarloanYear,
        tmpOtherloansPrice,
        tmpOtherloansYear,
        tmpAveragePrice,
        tmpAverageYear,
        tmpEduPrice,
        tmpEduYear
      );
    } else if (
      tmpMortgagePriceText == 0 &&
      tmpCarloanPriceText == 0 &&
      tmpOtherloansPriceText == 0 &&
      tmpAveragePriceText == 0 &&
      tmpEduPriceText == 0
    ) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
      ).addClass('none');
    }
    $('#includeprice').html(addCommas(tmpTotalInclude));
    $('#excludeprice').html(addCommas(tmpTotalExclude));
    if (tmpTotalInclude <= 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(0);
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(addCommas(tmpTotalPriceText));
    }
  });
  tmpOtherloansYear.keyup(function() {
    var tmpMortgagePriceText = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpMortgageYearText = tmpMortgageYear.val() ? tmpMortgageYear.val() : 0;
    var tmpCarloanPriceText = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpCarloanYearText = tmpCarloanYear.val() ? tmpCarloanYear.val() : 0;
    var tmpOtherloansPriceText = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpOtherloansYearText = tmpOtherloansYear.val()
      ? tmpOtherloansYear.val()
      : 0;
    var tmpAveragePriceText = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpAverageYearText = tmpAverageYear.text() ? tmpAverageYear.text() : 0;
    var tmpEduPriceText = tmpEduPrice.val()
      ? clearCommas(tmpEduPrice.val())
      : 0;
    var tmpEduYearText = tmpEduYear.val() ? tmpEduYear.val() : 0;
    var tmpTotalPriceText =
      parseInt(tmpMortgagePriceText, 10) +
      parseInt(tmpCarloanPriceText, 10) +
      parseInt(tmpOtherloansPriceText, 10) +
      parseInt(tmpAveragePriceText, 10) +
      parseInt(tmpEduPriceText, 10);
    var tmpTotalInclude =
      parseInt(tmpMortgagePriceText, 10) *
        12 *
        parseInt(tmpMortgageYearText, 10) +
      parseInt(tmpCarloanPriceText, 10) *
        12 *
        parseInt(tmpCarloanYearText, 10) +
      parseInt(tmpOtherloansPriceText, 10) *
        12 *
        parseInt(tmpOtherloansYearText, 10) +
      parseInt(tmpAveragePriceText, 10) *
        12 *
        parseInt(tmpAverageYearText, 10) +
      parseInt(tmpEduPriceText, 10) * 12 * parseInt(tmpEduYearText, 10);
    var tmpTotalExclude =
      parseInt(tmpTotalInclude, 10) -
      parseInt(tmpAveragePriceText, 10) * 12 * parseInt(tmpAverageYearText, 10);
    var tmpThisPriceVal = tmpOtherloansPrice.val();
    var tmpThisYearVal = tmpOtherloansYear.val();
    if (tmpThisPriceVal && tmpThisYearVal) {
      drawChart(
        tmpMortgagePrice,
        tmpMortgageYear,
        tmpCarloanPrice,
        tmpCarloanYear,
        tmpOtherloansPrice,
        tmpOtherloansYear,
        tmpAveragePrice,
        tmpAverageYear,
        tmpEduPrice,
        tmpEduYear
      );
    } else if (
      tmpMortgagePriceText == 0 &&
      tmpCarloanPriceText == 0 &&
      tmpOtherloansPriceText == 0 &&
      tmpAveragePriceText == 0 &&
      tmpEduPriceText == 0
    ) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
      ).addClass('none');
    }
    $('#includeprice').html(addCommas(tmpTotalInclude));
    $('#excludeprice').html(addCommas(tmpTotalExclude));
    if (tmpTotalInclude <= 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(0);
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(addCommas(tmpTotalPriceText));
    }
  });
  tmpAveragePrice.keyup(function() {
    var tmpThisValue = clearCommas($(this).val());
    $(this).val(addCommas(tmpThisValue));
    var tmpMortgagePriceText = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpMortgageYearText = tmpMortgageYear.val() ? tmpMortgageYear.val() : 0;
    var tmpCarloanPriceText = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpCarloanYearText = tmpCarloanYear.val() ? tmpCarloanYear.val() : 0;
    var tmpOtherloansPriceText = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpOtherloansYearText = tmpOtherloansYear.val()
      ? tmpOtherloansYear.val()
      : 0;
    var tmpAveragePriceText = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpAverageYearText = tmpAverageYear.text() ? tmpAverageYear.text() : 0;
    var tmpEduPriceText = tmpEduPrice.val()
      ? clearCommas(tmpEduPrice.val())
      : 0;
    var tmpEduYearText = tmpEduYear.val() ? tmpEduYear.val() : 0;
    var tmpTotalPriceText =
      parseInt(tmpMortgagePriceText, 10) +
      parseInt(tmpCarloanPriceText, 10) +
      parseInt(tmpOtherloansPriceText, 10) +
      parseInt(tmpAveragePriceText, 10) +
      parseInt(tmpEduPriceText, 10);
    var tmpTotalInclude =
      parseInt(tmpMortgagePriceText, 10) *
        12 *
        parseInt(tmpMortgageYearText, 10) +
      parseInt(tmpCarloanPriceText, 10) *
        12 *
        parseInt(tmpCarloanYearText, 10) +
      parseInt(tmpOtherloansPriceText, 10) *
        12 *
        parseInt(tmpOtherloansYearText, 10) +
      parseInt(tmpAveragePriceText, 10) *
        12 *
        parseInt(tmpAverageYearText, 10) +
      parseInt(tmpEduPriceText, 10) * 12 * parseInt(tmpEduYearText, 10);
    var tmpTotalExclude =
      parseInt(tmpTotalInclude, 10) -
      parseInt(tmpAveragePriceText, 10) * 12 * parseInt(tmpAverageYearText, 10);
    var tmpThisPriceVal = tmpAveragePrice.val();
    var tmpThisYearVal = tmpAverageYear.text();
    if (tmpThisPriceVal) {
      drawChart(
        tmpMortgagePrice,
        tmpMortgageYear,
        tmpCarloanPrice,
        tmpCarloanYear,
        tmpOtherloansPrice,
        tmpOtherloansYear,
        tmpAveragePrice,
        tmpAverageYear,
        tmpEduPrice,
        tmpEduYear
      );
    } else if (
      tmpMortgagePriceText == 0 &&
      tmpCarloanPriceText == 0 &&
      tmpOtherloansPriceText == 0 &&
      tmpAveragePriceText == 0 &&
      tmpEduPriceText == 0
    ) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
      ).addClass('none');
    } else {
      drawChart(
        tmpMortgagePrice,
        tmpMortgageYear,
        tmpCarloanPrice,
        tmpCarloanYear,
        tmpOtherloansPrice,
        tmpOtherloansYear,
        '',
        tmpAverageYear,
        tmpEduPrice,
        tmpEduYear
      );
    }
    $('#includeprice').html(addCommas(tmpTotalInclude));
    $('#excludeprice').html(addCommas(tmpTotalExclude));
    if (tmpTotalInclude <= 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(0);
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(addCommas(tmpTotalPriceText));
    }
  });
  tmpEduPrice.keyup(function() {
    var tmpThisValue = clearCommas($(this).val());
    $(this).val(addCommas(tmpThisValue));
    var tmpMortgagePriceText = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpMortgageYearText = tmpMortgageYear.val() ? tmpMortgageYear.val() : 0;
    var tmpCarloanPriceText = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpCarloanYearText = tmpCarloanYear.val() ? tmpCarloanYear.val() : 0;
    var tmpOtherloansPriceText = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpOtherloansYearText = tmpOtherloansYear.val()
      ? tmpOtherloansYear.val()
      : 0;
    var tmpAveragePriceText = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpAverageYearText = tmpAverageYear.text() ? tmpAverageYear.text() : 0;
    var tmpEduPriceText = tmpEduPrice.val()
      ? clearCommas(tmpEduPrice.val())
      : 0;
    var tmpEduYearText = tmpEduYear.val() ? tmpEduYear.val() : 0;
    var tmpTotalPriceText =
      parseInt(tmpMortgagePriceText, 10) +
      parseInt(tmpCarloanPriceText, 10) +
      parseInt(tmpOtherloansPriceText, 10) +
      parseInt(tmpAveragePriceText, 10) +
      parseInt(tmpEduPriceText, 10);
    var tmpTotalInclude =
      parseInt(tmpMortgagePriceText, 10) *
        12 *
        parseInt(tmpMortgageYearText, 10) +
      parseInt(tmpCarloanPriceText, 10) *
        12 *
        parseInt(tmpCarloanYearText, 10) +
      parseInt(tmpOtherloansPriceText, 10) *
        12 *
        parseInt(tmpOtherloansYearText, 10) +
      parseInt(tmpAveragePriceText, 10) *
        12 *
        parseInt(tmpAverageYearText, 10) +
      parseInt(tmpEduPriceText, 10) * 12 * parseInt(tmpEduYearText, 10);
    var tmpTotalExclude =
      parseInt(tmpTotalInclude, 10) -
      parseInt(tmpAveragePriceText, 10) * 12 * parseInt(tmpAverageYearText, 10);
    var tmpThisPriceVal = tmpEduPrice.val();
    var tmpThisYearVal = tmpEduYear.val();
    if (tmpThisPriceVal && tmpThisYearVal) {
      drawChart(
        tmpMortgagePrice,
        tmpMortgageYear,
        tmpCarloanPrice,
        tmpCarloanYear,
        tmpOtherloansPrice,
        tmpOtherloansYear,
        tmpAveragePrice,
        tmpAverageYear,
        tmpEduPrice,
        tmpEduYear
      );
    } else if (
      tmpMortgagePriceText == 0 &&
      tmpCarloanPriceText == 0 &&
      tmpOtherloansPriceText == 0 &&
      tmpAveragePriceText == 0 &&
      tmpEduPriceText == 0
    ) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
      ).addClass('none');
    }
    $('#includeprice').html(addCommas(tmpTotalInclude));
    $('#excludeprice').html(addCommas(tmpTotalExclude));
    if (tmpTotalInclude <= 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(0);
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(addCommas(tmpTotalPriceText));
    }
  });
  tmpEduYear.keyup(function() {
    var tmpMortgagePriceText = tmpMortgagePrice.val()
      ? clearCommas(tmpMortgagePrice.val())
      : 0;
    var tmpMortgageYearText = tmpMortgageYear.val() ? tmpMortgageYear.val() : 0;
    var tmpCarloanPriceText = tmpCarloanPrice.val()
      ? clearCommas(tmpCarloanPrice.val())
      : 0;
    var tmpCarloanYearText = tmpCarloanYear.val() ? tmpCarloanYear.val() : 0;
    var tmpOtherloansPriceText = tmpOtherloansPrice.val()
      ? clearCommas(tmpOtherloansPrice.val())
      : 0;
    var tmpOtherloansYearText = tmpOtherloansYear.val()
      ? tmpOtherloansYear.val()
      : 0;
    var tmpAveragePriceText = tmpAveragePrice.val()
      ? clearCommas(tmpAveragePrice.val())
      : 0;
    var tmpAverageYearText = tmpAverageYear.text() ? tmpAverageYear.text() : 0;
    var tmpEduPriceText = tmpEduPrice.val()
      ? clearCommas(tmpEduPrice.val())
      : 0;
    var tmpEduYearText = tmpEduYear.val() ? tmpEduYear.val() : 0;
    var tmpTotalPriceText =
      parseInt(tmpMortgagePriceText, 10) +
      parseInt(tmpCarloanPriceText, 10) +
      parseInt(tmpOtherloansPriceText, 10) +
      parseInt(tmpAveragePriceText, 10) +
      parseInt(tmpEduPriceText, 10);
    var tmpTotalInclude =
      parseInt(tmpMortgagePriceText, 10) *
        12 *
        parseInt(tmpMortgageYearText, 10) +
      parseInt(tmpCarloanPriceText, 10) *
        12 *
        parseInt(tmpCarloanYearText, 10) +
      parseInt(tmpOtherloansPriceText, 10) *
        12 *
        parseInt(tmpOtherloansYearText, 10) +
      parseInt(tmpAveragePriceText, 10) *
        12 *
        parseInt(tmpAverageYearText, 10) +
      parseInt(tmpEduPriceText, 10) * 12 * parseInt(tmpEduYearText, 10);
    var tmpTotalExclude =
      parseInt(tmpTotalInclude, 10) -
      parseInt(tmpAveragePriceText, 10) * 12 * parseInt(tmpAverageYearText, 10);
    var tmpThisPriceVal = tmpEduPrice.val();
    var tmpThisYearVal = tmpEduYear.val();
    if (tmpThisPriceVal && tmpThisYearVal) {
      drawChart(
        tmpMortgagePrice,
        tmpMortgageYear,
        tmpCarloanPrice,
        tmpCarloanYear,
        tmpOtherloansPrice,
        tmpOtherloansYear,
        tmpAveragePrice,
        tmpAverageYear,
        tmpEduPrice,
        tmpEduYear
      );
    } else if (
      tmpMortgagePriceText == 0 &&
      tmpCarloanPriceText == 0 &&
      tmpOtherloansPriceText == 0 &&
      tmpAveragePriceText == 0 &&
      tmpEduPriceText == 0
    ) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .demandbox'
      ).addClass('none');
    }
    $('#includeprice').html(addCommas(tmpTotalInclude));
    $('#excludeprice').html(addCommas(tmpTotalExclude));
    if (tmpTotalInclude <= 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(0);
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .expenditureblock .row-comment .resultbox .resultstr.money'
      ).text(addCommas(tmpTotalPriceText));
    }
  });
  $('[name="hospitalprice"]').keyup(function() {
    var tmpVal = $(this).val() ? clearCommas($(this).val()) : 0;
    $(this).val(addCommas(tmpVal));
    var tmpHosVal = $('[name="hospital"]').val()
      ? $('[name="hospital"]').val()
      : 0;
    var tmpPrice =
      parseInt(clearCommas(tmpVal), 10) - parseInt(clearCommas(tmpHosVal), 10);
    if (tmpPrice > 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital'
      )
        .html(addCommas(tmpPrice))
        .addClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text'
      ).addClass('none');
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital'
      )
        .html(addCommas(tmpPrice))
        .removeClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text'
      ).removeClass('none');
    }
  });
  $('[name="hospital"]').keyup(function() {
    var tmpVal = $(this).val() ? clearCommas($(this).val()) : 0;
    $(this).val(addCommas(tmpVal));
    var tmpHosVal = $('[name="hospitalprice"]').val()
      ? $('[name="hospitalprice"]').val()
      : 0;
    var tmpPrice =
      parseInt(clearCommas(tmpHosVal), 10) - parseInt(clearCommas(tmpVal), 10);
    if (tmpPrice > 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital'
      )
        .html(addCommas(tmpPrice))
        .addClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text'
      ).addClass('none');
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital'
      )
        .html(addCommas(tmpPrice))
        .removeClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text'
      ).removeClass('none');
    }
  });
  $('[name="incapacitation"]').keyup(function() {
    var tmpVal = $(this).val() ? clearCommas($(this).val()) : 0;
    $(this).val(addCommas(tmpVal));
    var tmpAllow = $('[name="allowance"]').val()
      ? $('[name="allowance"]').val()
      : 0;
    var tmpSelf = $('[name="selfinsurance"]').val()
      ? $('[name="selfinsurance"]').val()
      : 0;
    var tmpTotal =
      parseInt(clearCommas(tmpAllow), 10) +
      parseInt(clearCommas(tmpSelf), 10) -
      parseInt(clearCommas(tmpVal), 10);
    if (tmpTotal > 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow'
      )
        .html(addCommas(tmpTotal))
        .addClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text'
      ).addClass('none');
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow'
      )
        .html(addCommas(tmpTotal))
        .removeClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text'
      ).removeClass('none');
    }
  });
  $('[name="allowance"]').keyup(function() {
    var tmpVal = $(this).val() ? clearCommas($(this).val()) : 0;
    $(this).val(addCommas(tmpVal));
    var tmpIncapa = $('[name="incapacitation"]').val()
      ? $('[name="incapacitation"]').val()
      : 0;
    var tmpSelf = $('[name="selfinsurance"]').val()
      ? $('[name="selfinsurance"]').val()
      : 0;
    var tmpTotal =
      parseInt(clearCommas(tmpVal), 10) +
      parseInt(clearCommas(tmpSelf), 10) -
      parseInt(clearCommas(tmpIncapa), 10);
    if (tmpTotal > 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow'
      )
        .html(addCommas(tmpTotal))
        .addClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text'
      ).addClass('none');
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow'
      )
        .html(addCommas(tmpTotal))
        .removeClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text'
      ).removeClass('none');
    }
  });
  $('[name="selfinsurance"]').keyup(function() {
    var tmpVal = $(this).val() ? clearCommas($(this).val()) : 0;
    $(this).val(addCommas(tmpVal));
    var tmpAllow = $('[name="allowance"]').val()
      ? $('[name="allowance"]').val()
      : 0;
    var tmpIncapa = $('[name="incapacitation"]').val()
      ? $('[name="incapacitation"]').val()
      : 0;
    var tmpTotal =
      parseInt(clearCommas(tmpAllow), 10) +
      parseInt(clearCommas(tmpVal), 10) -
      parseInt(clearCommas(tmpIncapa), 10);
    if (tmpTotal > 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow'
      )
        .html(addCommas(tmpTotal))
        .addClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text'
      ).addClass('none');
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow'
      )
        .html(addCommas(tmpTotal))
        .removeClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox span.text'
      ).removeClass('none');
    }
  });
  $('[name="retireoutlay"]').keyup(function() {
    var tmpVal = $(this).val() ? clearCommas($(this).val()) : 0;
    $(this).val(addCommas(tmpVal));
    var tmpOut = $('[name="retireoutlay"]').val()
      ? $('[name="retireoutlay"]').val()
      : 0;
    var tmpBi = $('[name="retirebilingual"]').val()
      ? $('[name="retirebilingual"]').val()
      : 0;
    var tmpIns = $('[name="retireinsurance"]').val()
      ? $('[name="retireinsurance"]').val()
      : 0;
    var tmpOther = $('[name="retireother"]').val()
      ? $('[name="retireother"]').val()
      : 0;
    var tmpTotal =
      parseInt(clearCommas(tmpBi), 10) +
      parseInt(clearCommas(tmpIns), 10) +
      parseInt(clearCommas(tmpOther), 10) -
      parseInt(clearCommas(tmpOut), 10);
    if (tmpTotal > 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney'
      )
        .html(addCommas(tmpTotal))
        .addClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text'
      ).addClass('none');
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney'
      )
        .html(addCommas(tmpTotal))
        .removeClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text'
      ).removeClass('none');
    }
  });
  $('[name="retirebilingual"]').keyup(function() {
    var tmpVal = $(this).val() ? clearCommas($(this).val()) : 0;
    $(this).val(addCommas(tmpVal));
    var tmpOut = $('[name="retireoutlay"]').val()
      ? $('[name="retireoutlay"]').val()
      : 0;
    var tmpBi = $('[name="retirebilingual"]').val()
      ? $('[name="retirebilingual"]').val()
      : 0;
    var tmpIns = $('[name="retireinsurance"]').val()
      ? $('[name="retireinsurance"]').val()
      : 0;
    var tmpOther = $('[name="retireother"]').val()
      ? $('[name="retireother"]').val()
      : 0;
    var tmpTotal =
      parseInt(clearCommas(tmpBi), 10) +
      parseInt(clearCommas(tmpIns), 10) +
      parseInt(clearCommas(tmpOther), 10) -
      parseInt(clearCommas(tmpOut), 10);
    if (tmpTotal > 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney'
      )
        .html(addCommas(tmpTotal))
        .addClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text'
      ).addClass('none');
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney'
      )
        .html(addCommas(tmpTotal))
        .removeClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text'
      ).removeClass('none');
    }
  });
  $('[name="retireinsurance"]').keyup(function() {
    var tmpVal = $(this).val() ? clearCommas($(this).val()) : 0;
    $(this).val(addCommas(tmpVal));
    var tmpOut = $('[name="retireoutlay"]').val()
      ? $('[name="retireoutlay"]').val()
      : 0;
    var tmpBi = $('[name="retirebilingual"]').val()
      ? $('[name="retirebilingual"]').val()
      : 0;
    var tmpIns = $('[name="retireinsurance"]').val()
      ? $('[name="retireinsurance"]').val()
      : 0;
    var tmpOther = $('[name="retireother"]').val()
      ? $('[name="retireother"]').val()
      : 0;
    var tmpTotal =
      parseInt(clearCommas(tmpBi), 10) +
      parseInt(clearCommas(tmpIns), 10) +
      parseInt(clearCommas(tmpOther), 10) -
      parseInt(clearCommas(tmpOut), 10);
    if (tmpTotal > 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney'
      )
        .html(addCommas(tmpTotal))
        .addClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text'
      ).addClass('none');
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney'
      )
        .html(addCommas(tmpTotal))
        .removeClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text'
      ).removeClass('none');
    }
  });
  $('[name="retireother"]').keyup(function() {
    var tmpVal = $(this).val() ? clearCommas($(this).val()) : 0;
    $(this).val(addCommas(tmpVal));
    var tmpOut = $('[name="retireoutlay"]').val()
      ? $('[name="retireoutlay"]').val()
      : 0;
    var tmpBi = $('[name="retirebilingual"]').val()
      ? $('[name="retirebilingual"]').val()
      : 0;
    var tmpIns = $('[name="retireinsurance"]').val()
      ? $('[name="retireinsurance"]').val()
      : 0;
    var tmpOther = $('[name="retireother"]').val()
      ? $('[name="retireother"]').val()
      : 0;
    var tmpTotal =
      parseInt(clearCommas(tmpBi, 10), 10) +
      parseInt(clearCommas(tmpIns, 10), 10) +
      parseInt(clearCommas(tmpOther, 10), 10) -
      parseInt(clearCommas(tmpOut, 10), 10);
    if (tmpTotal > 0) {
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney'
      )
        .html(addCommas(tmpTotal))
        .addClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text'
      ).addClass('none');
    } else {
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney'
      )
        .html(addCommas(tmpTotal))
        .removeClass('abs');
      $(
        '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox span.text'
      ).removeClass('none');
    }
  });
  $('[name="averageprice"]').click(function() {
    var tmpThis = $(this);
    var tmpDatepicker = $('#datepickerbox input').val()
      ? $('#datepickerbox input').val()
      : '';
    if (!tmpDatepicker) {
      // swal({
      //   title: '',
      //   type: 'info',
      //   html: '請選擇生日',
      //   confirmButtonText: '我知道了',
      // }).then(function() {
      //   tmpThis.val('').attr('disabled', true);
      // });
    } else {
      tmpThis.attr('disabled', false);
    }
  });
  $('[name="gender"]').change(function() {
    var tmpVal = $(this).val();
    var tmpEstimatedVal = $('[name="estimated"]').val()
      ? $('[name="estimated"]').val()
      : 0;
    $('[name="estimated"]').attr('disabled', false);
    if (tmpVal == '男') {
      if (tmpEstimatedVal >= 77) {
        $('[name="survival"]').val('');
      } else {
        let tmpTotalEs = 77 - parseInt(tmpEstimatedVal, 10);
        $('[name="survival"]').val(tmpTotalEs);
      }
    } else if (tmpVal == '女') {
      if (tmpEstimatedVal >= 84) {
        $('[name="survival"]').val('');
      } else {
        let tmpTotalEs = 84 - parseInt(tmpEstimatedVal, 10);
        $('[name="survival"]').val(tmpTotalEs);
      }
    } else {
      $('[name="survival"]').val('');
    }
  });
  $('[name="estimated"]').click(function() {
    var tmpThis = $(this);
    var tmpGender = $('[name="gender"]').val()
      ? $('[name="gender"]').val()
      : '';
    if (!tmpGender) {
      // swal({
      //   title: '',
      //   type: 'info',
      //   html: '請選擇性別',
      //   confirmButtonText: '我知道了',
      // }).then(function() {
      //   tmpThis.val('');
      //   tmpThis.attr('disabled', true);
      // });
    }
  });
  $('[name="estimated"]').keyup(function() {
    var tmpThis = $(this);
    var tmpEstimatedVal = tmpThis.val() ? tmpThis.val() : 0;
    var tmpSurvival = $('[name="survival"]').val()
      ? $('[name="survival"]').val()
      : 0;
    var tmpGender = $('[name="gender"]').val()
      ? $('[name="gender"]').val()
      : '';
    if (tmpGender == '男') {
      if (tmpEstimatedVal >= 77) {
        $('[name="survival"]').val('');
      } else {
        let tmpTotalEs = 77 - parseInt(tmpEstimatedVal, 10);
        $('[name="survival"]').val(tmpTotalEs);
      }
    } else if (tmpGender == '女') {
      if (tmpEstimatedVal >= 84) {
        $('[name="survival"]').val('');
      } else {
        let tmpTotalEs = 84 - parseInt(tmpEstimatedVal, 10);
        $('[name="survival"]').val(tmpTotalEs);
      }
    }
  });

  // 病房費計算
  $('#choosehospital').click(function() {
    var tmpHtml =
      '<div class="cibchospitalbox">' +
      '<ul>' +
      '<li><span>區域</span><div class="box"><select id="area"><option value="">請選擇區域</option><option value="北區">北區</option><option value="中區">中區</option><option value="南區">南區</option><option value="宜花東">宜花東</option></select></div></li>' +
      '<li><span>醫院名稱</span><div class="box"><select id="name"><option value="">請選擇醫院名稱</option></select></div></li>' +
      '<li><span>選擇房型</span><div class="box"><select id="roomtype"><option value="">請選擇房型</option></select></div></li>' +
      '</ul>' +
      '</div>';
    // swal({
    //   title: '請選擇醫院病房費',
    //   html: tmpHtml,
    //   confirmButtonText: '確定',
    //   confirmButtonColor: '#3085d6',
    //   showCancelButton: true,
    //   cancelButtonText: '取消',
    //   cancelButtonColor: '#d33',
    // }).then(
    //   function() {
    //     var tmpRoomType = $('#roomtype').val() ? $('#roomtype').val() : '';
    //     $('[name="hospital"]').val(addCommas(tmpRoomType));
    //     var tmpHospitalPriceVal = $('[name="hospitalprice"]').val()
    //       ? $('[name="hospitalprice"]').val()
    //       : 0;
    //     var tmpHospitalVal = tmpRoomType ? tmpRoomType : 0;
    //     var tmpPrice =
    //       parseInt(clearCommas(tmpHospitalPriceVal)) -
    //       parseInt(clearCommas(tmpHospitalVal));
    //     if (tmpPrice > 0) {
    //       $(
    //         '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital'
    //       )
    //         .html(addCommas(tmpPrice))
    //         .addClass('abs');
    //       $(
    //         '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text'
    //       ).addClass('none');
    //     } else {
    //       $(
    //         '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital'
    //       )
    //         .html(addCommas(tmpPrice))
    //         .removeClass('abs');
    //       $(
    //         '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox span.text'
    //       ).removeClass('none');
    //     }
    //   },
    //   function(dismiss) {
    //     if (dismiss == 'cancel') {
    //     }
    //   }
    // );
    dialogChange();
  });
  function dialogChange() {
    var hospitalName = {
      北區: [
        '台北醫學院',
        '國泰醫院',
        '新光醫院',
        '馬偕醫院',
        '亞東醫院',
        '恩主公醫院',
        '敏盛醫院',
      ],
      中區: [
        '中國醫藥學院',
        '台中榮總',
        '澄清醫院',
        '埔里基督教',
        '彰化基督教',
      ],
      南區: [
        '嘉義基督教',
        '嘉義長庚',
        '成大醫院',
        '奇美醫院',
        '高雄榮總',
        '高雄長庚',
        '高雄醫學院',
        '屏東基督教',
      ],
      宜花東: ['羅東博愛', '門諾醫院', '花蓮慈濟', '台東馬偕'],
    };
    var hospitalMoney = {
      台北醫學院: [4000, 2000],
      國泰醫院: [4560, 2060],
      新光醫院: [4550, 2200],
      馬偕醫院: [4500, 2500],
      亞東醫院: [3000, 2000],
      恩主公醫院: [3450, 1200],
      敏盛醫院: [4500, 1800],
      中國醫藥學院: [3980, 1980],
      台中榮總: [3380, 1800],
      澄清醫院: [3400, 2400],
      埔里基督教: [2500, 1200],
      彰化基督教: [2800, 1600],
      嘉義基督教: [2500, 1500],
      嘉義長庚: [2500, 1200],
      成大醫院: [2900, 1580],
      奇美醫院: [2500, 1680],
      高雄榮總: [3000, 1500],
      高雄長庚: [3000, 1500],
      高雄醫學院: [2300, 1400],
      屏東基督教: [2500, 1200],
      羅東博愛: [2000, 1000],
      門諾醫院: [2000, 1000],
      花蓮慈濟: [2000, 1000],
      台東馬偕: [2000, 1000],
    };
    $('#name').attr('disabled', true);
    $('#roomtype').attr('disabled', true);
    $('#area').change(function() {
      var tmpVal = $(this).val();
      var tmpStr = '',
        tmpResult = '';
      for (var i = 0; i < hospitalName[tmpVal].length; i++) {
        tmpStr =
          '<option value="' +
          hospitalName[tmpVal][i] +
          '">' +
          hospitalName[tmpVal][i] +
          '</option>';
        tmpResult = tmpResult + tmpStr;
      }
      $('#name')
        .html('<option value="">請選擇醫院名稱</option>' + tmpResult)
        .attr('disabled', false);
    });
    $('#name').change(function() {
      var tmpVal = $(this).val();
      var tmpStr = '',
        tmpResult = '';
      for (var i = 0; i < hospitalMoney[tmpVal].length; i++) {
        if (i == 0) {
          tmpStr =
            '<option value="' +
            hospitalMoney[tmpVal][i] +
            '">普通單人房</option>';
        } else if (i == 1) {
          tmpStr =
            '<option value="' +
            hospitalMoney[tmpVal][i] +
            '">普通雙人房</option>';
        }
        tmpResult = tmpResult + tmpStr;
      }
      $('#roomtype')
        .html(tmpResult)
        .attr('disabled', false);
    });
  }

  // Html to PDF
  $('#html2pdfBtn').click(function() {
    var tmpName = $('[name="name"]').val() ? $('[name="name"]').val() : '';
    var tmpBirth = $('#datepickerbox input').val()
      ? $('#datepickerbox input').val()
      : '';
    var tmpGender = $('[name="gender"]').val()
      ? $('[name="gender"]').val()
      : '';
    var tmpAge = $(
      '.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age'
    ).text()
      ? $(
          '.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.age'
        ).text()
      : '';
    var tmpYear = $(
      '.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.year'
    ).text()
      ? $(
          '.wrapper.cibc-cal   .contentbox .infoblock .row-comment .resultbox .resultstr.year'
        ).text()
      : '';
    var tmpStableincome = $('[name="stableincome"]').val()
      ? $('[name="stableincome"]').val()
      : '';
    var tmpOtherincome = $('[name="otherincome"]').val()
      ? $('[name="otherincome"]').val()
      : '';
    var tmpTotalIncome = $(
      '.wrapper.cibc-cal   .contentbox .incomeblock .row-comment .resultbox .resultstr.incomemoney'
    ).text();
    var tmpMortgagePrice = $('[name="mortgageprice"]').val()
      ? $('[name="mortgageprice"]').val()
      : '';
    var tmpMortgageYear = $('[name="mortgageyear"]').val()
      ? $('[name="mortgageyear"]').val()
      : '';
    var tmpCarloanPrice = $('[name="carloanprice"]').val()
      ? $('[name="carloanprice"]').val()
      : '';
    var tmpCarloanYear = $('[name="carloanyear"]').val()
      ? $('[name="carloanyear"]').val()
      : '';
    var tmpOtherloansPrice = $('[name="otherloansprice"]').val()
      ? $('[name="otherloansprice"]').val()
      : '';
    var tmpOtherloansYear = $('[name="otherloansyear"]').val()
      ? $('[name="otherloansyear"]').val()
      : '';
    var tmpAveragePrice = $('[name="averageprice"]').val()
      ? $('[name="averageprice"]').val()
      : '';
    var tmpAverageYear = $('#averageyear').text()
      ? $('#averageyear').text()
      : '';
    var tmpEduPrice = $('[name="eduprice"]').val()
      ? $('[name="eduprice"]').val()
      : '';
    var tmpEduYear = $('[name="eduyear"]').val()
      ? $('[name="eduyear"]').val()
      : '';

    var tmpExcludeprice = $('#excludeprice').text()
      ? $('#excludeprice').text()
      : '';
    var tmpIncludeprice = $('#includeprice').text()
      ? $('#includeprice').text()
      : '';

    var tmpLifeinsurance = $('#lifeinsuranceprice').text()
      ? $('#lifeinsuranceprice').text()
      : '';
    var tmpInandoutcome = $('#inandoutcomeprice').text()
      ? $('#inandoutcomeprice').text()
      : '';
    var tmpHospitalprice = $('[name="hospitalprice"]').val()
      ? $('[name="hospitalprice"]').val()
      : '';
    var tmpHospital = $('[name="hospital"]').val()
      ? $('[name="hospital"]').val()
      : '';
    var tmpHospitalTotal = $(
      '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital'
    ).text()
      ? $(
          '.wrapper.cibc-cal   .contentbox .hospitalizebox .resultbox .price.hospital'
        ).text()
      : '';
    var tmpIncapacitation = $('[name="incapacitation"]').val()
      ? $('[name="incapacitation"]').val()
      : '';
    var tmpAllowance = $('[name="allowance"]').val()
      ? $('[name="allowance"]').val()
      : '';
    var tmpSelfinsurance = $('[name="selfinsurance"]').val()
      ? $('[name="selfinsurance"]').val()
      : '';
    var tmpAllowTotal = $(
      '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow'
    ).text()
      ? $(
          '.wrapper.cibc-cal   .contentbox .longtermcarebox .resultbox .price.allow'
        ).text()
      : '';

    var tmpEstimated = $('[name="estimated"]').val()
      ? $('[name="estimated"]').val()
      : '';
    var tmpSurival = $('[name="survival"]').val()
      ? $('[name="survival"]').val()
      : '';
    var tmpRetireoutlay = $('[name="retireoutlay"]').val()
      ? $('[name="retireoutlay"]').val()
      : '';
    var tmpRetirebilingual = $('[name="retirebilingual"]').val()
      ? $('[name="retirebilingual"]').val()
      : '';
    var tmpRetireinsurance = $('[name="retireinsurance"]').val()
      ? $('[name="retireinsurance"]').val()
      : '';
    var tmpRetireother = $('[name="retireother"]').val()
      ? $('[name="retireother"]').val()
      : '';
    var tmpRetiremoney = $(
      '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney'
    ).text()
      ? $(
          '.wrapper.cibc-cal   .contentbox .retirebox .row-comment .resultbox .resultstr.retiremoney'
        ).text()
      : '';

    $(
      '#printcibxblock .middlebox .sectionbox .calbox .right ul li .rightcontent.infoname'
    ).text(tmpName);
    $(
      '#printcibxblock .middlebox .sectionbox .calbox .right ul li .rightcontent.infobirth'
    ).text(tmpBirth);
    $(
      '#printcibxblock .middlebox .sectionbox .calbox .right ul li .rightcontent.infogender'
    ).text(tmpGender);
    $('#printcibxblock .middlebox .sectionbox .resultbox .number.inage').text(
      tmpAge
    );
    $('#printcibxblock .middlebox .sectionbox .resultbox .number.reage').text(
      tmpYear
    );
    $(
      '#printcibxblock .middlebox .incomebox .calbox .right ul li .rightcontent.incomeone'
    ).text(addCommas(tmpStableincome) + ' 元');
    $(
      '#printcibxblock .middlebox .incomebox .calbox .right ul li .rightcontent.incometwo'
    ).text(addCommas(tmpOtherincome) + ' 元');
    $(
      '#printcibxblock .middlebox .incomebox .resultbox .number.totalincome'
    ).text(tmpTotalIncome);

    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.one[data-id="1"]'
    ).text(addCommas(tmpMortgagePrice));
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.two[data-id="1"]'
    ).text(tmpMortgageYear);
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.one[data-id="2"]'
    ).text(addCommas(tmpCarloanPrice));
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.two[data-id="2"]'
    ).text(tmpCarloanYear);
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.one[data-id="3"]'
    ).text(addCommas(tmpOtherloansPrice));
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.two[data-id="3"]'
    ).text(tmpOtherloansYear);
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.one[data-id="4"]'
    ).text(addCommas(tmpAveragePrice));
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.two[data-id="4"]'
    ).text(tmpAverageYear);
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.one[data-id="5"]'
    ).text(addCommas(tmpEduPrice));
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .info ul li .number.two[data-id="5"]'
    ).text(tmpEduYear);
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .chartbox .totalpricebox ul li .price.excludeprice'
    ).text(tmpExcludeprice);
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .chartbox .totalpricebox ul li .price.includeprice'
    ).text(tmpIncludeprice);

    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .chartbox .totalinfobox ul li .price.life'
    ).text(tmpLifeinsurance);
    $(
      '#printcibxblock .middlebox .expenditurebox .calbox .right .chartbox .totalinfobox ul li .price.inandout'
    ).text(addCommas(tmpInandoutcome));

    $(
      '#printcibxblock .middlebox .hospitalizebox .calbox .right ul li .price.one'
    ).text(addCommas(tmpHospitalprice));
    $(
      '#printcibxblock .middlebox .hospitalizebox .calbox .right ul li .price.two'
    ).text(addCommas(tmpHospital));
    if (parseInt(tmpHospitalTotal, 10) > 0) {
      $('#printcibxblock .middlebox .hospitalizebox .resultbox .number')
        .text(tmpHospitalTotal)
        .css('color', '#005aaa')
        .parent()
        .find('.text')
        .addClass('none');
    } else {
      $('#printcibxblock .middlebox .hospitalizebox .resultbox .number')
        .text(tmpHospitalTotal)
        .css('color', '#ff0000')
        .parent()
        .find('.text')
        .removeClass('none');
    }
    $(
      '#printcibxblock .middlebox .longtermcarebox .calbox .right ul.longtermcaretop li span.price'
    ).text(addCommas(tmpIncapacitation));
    $(
      '#printcibxblock .middlebox .longtermcarebox .calbox .right ul.longtermcarebottom li .price.one'
    ).text(addCommas(tmpAllowance));
    $(
      '#printcibxblock .middlebox .longtermcarebox .calbox .right ul.longtermcarebottom li .price.two'
    ).text(addCommas(tmpSelfinsurance));
    if (parseInt(tmpAllowTotal, 10) > 0) {
      $('#printcibxblock .middlebox .longtermcarebox .resultbox .number')
        .text(tmpAllowTotal)
        .css('color', '#005aaa')
        .parent()
        .find('.text')
        .addClass('none');
    } else {
      $('#printcibxblock .middlebox .longtermcarebox .resultbox .number')
        .text(tmpAllowTotal)
        .css('color', '#ff0000')
        .parent()
        .find('.text')
        .removeClass('none');
    }

    $(
      '#printcibxblock .middlebox .retirebox .calbox .right .retiretop span.one'
    ).text(tmpEstimated);
    $(
      '#printcibxblock .middlebox .retirebox .calbox .right .retiretop span.two'
    ).text(tmpSurival);
    $(
      '#printcibxblock .middlebox .retirebox .calbox .right ul.retiremiddle li .price.one'
    ).text(addCommas(tmpRetireoutlay));
    $(
      '#printcibxblock .middlebox .retirebox .calbox .right ul.retiremiddle li .price.two'
    ).text(addCommas(tmpRetirebilingual));
    $(
      '#printcibxblock .middlebox .retirebox .calbox .right ul.retirebottom li .price.one'
    ).text(addCommas(tmpRetireinsurance));
    $(
      '#printcibxblock .middlebox .retirebox .calbox .right ul.retirebottom li .price.two'
    ).text(addCommas(tmpRetireother));
    if (parseInt(tmpRetiremoney, 10) > 0) {
      $('#printcibxblock .middlebox .retirebox .resultbox .number')
        .text(tmpRetiremoney)
        .css('color', '#005aaa')
        .parent()
        .find('.text')
        .html('退休後每月餘額');
    } else {
      $('#printcibxblock .middlebox .retirebox .resultbox .number')
        .text(tmpRetiremoney)
        .css('color', '#ff0000')
        .parent()
        .find('.text')
        .html('退休後每月尚差');
    }

    $('#printcibxblock').removeClass('none');

    $.LoadingOverlay('show', {
      // image: "https://pc4appcdn.azureedge.net/assets/plugins/jquery-lodingoverlay/src/loading.gif",
    });
    // html2canvas($('#printcibxblock').get(0), {
    //   scale: 4,
    //   onrendered: function(canvas) {
    //     var ctx = canvas.getContext('2d');
    //     ctx.scale(2, 2);
    //     ctx.fillStyle = '#ffffff';
    //     var pageData = canvas.toDataURL('image/png', 1.0);
    //     var pdf = new jsPDF('', 'pt', 'a4');
    //     pdf.internal.scaleFactor = 2;
    //     pdf.addImage(
    //       pageData,
    //       'PNG',
    //       0,
    //       0,
    //       595.28,
    //       (592.28 / canvas.width) * canvas.height
    //     );
    //     pdf.save('保障試算結果.pdf');
    //     $('#printcibxblock').addClass('none');

    //     $.LoadingOverlay('hide');
    //   },
    // });
  });
};



// WEBPACK FOOTER //
// ./src/blocks/cibc/cibc-calculation.js